(() => {

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lwga2", function(module, exports) {

$parcel$export(module.exports, "default", () => $faa91f5616b3e685$export$2e2bcd8739ae039);
/*! @vimeo/player v2.30.4 | (c) 2026 Vimeo | MIT License | https://github.com/vimeo/player.js */ /**
 * @module lib/functions
 */ /**
 * Check to see this is a Node environment.
 * @type {boolean}
 */ /* global global */ const $faa91f5616b3e685$var$isNode = typeof $parcel$global !== 'undefined' && ({}).toString.call($parcel$global) === '[object global]';
/**
 * Check to see if this is a Bun environment.
 * @see https://bun.sh/guides/util/detect-bun
 * @type {boolean}
 */ const $faa91f5616b3e685$var$isBun = typeof Bun !== 'undefined';
/**
 * Check to see if this is a Deno environment.
 * @see https://docs.deno.com/api/deno/~/Deno
 * @type {boolean}
 */ const $faa91f5616b3e685$var$isDeno = typeof Deno !== 'undefined';
/**
 * Check to see if this is a Cloudflare Worker environment.
 * @see https://community.cloudflare.com/t/how-to-detect-the-cloudflare-worker-runtime/293715
 * @type {boolean}
 */ const $faa91f5616b3e685$var$isCloudflareWorker = typeof WebSocketPair === 'function' && typeof caches?.default !== 'undefined';
/**
 * Check if this is a server runtime
 * @type {boolean}
 */ const $faa91f5616b3e685$var$isServerRuntime = $faa91f5616b3e685$var$isNode || $faa91f5616b3e685$var$isBun || $faa91f5616b3e685$var$isDeno || $faa91f5616b3e685$var$isCloudflareWorker;
/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */ function $faa91f5616b3e685$var$getMethodName(prop, type) {
    if (prop.indexOf(type.toLowerCase()) === 0) return prop;
    return `${type.toLowerCase()}${prop.substr(0, 1).toUpperCase()}${prop.substr(1)}`;
}
/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */ function $faa91f5616b3e685$var$isDomElement(element) {
    return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
}
/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */ function $faa91f5616b3e685$var$isInteger(value) {
    // eslint-disable-next-line eqeqeq
    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}
/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $faa91f5616b3e685$var$isVimeoUrl(url) {
    return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(url);
}
/**
 * Check to see if the URL is for a Vimeo embed.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $faa91f5616b3e685$var$isVimeoEmbed(url) {
    const expr = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
    return expr.test(url);
}
function $faa91f5616b3e685$var$getOembedDomain(url) {
    const match = (url || '').match(/^(?:https?:)?(?:\/\/)?([^/?]+)/);
    const domain = (match && match[1] || '').replace('player.', '');
    const customDomains = [
        '.videoji.hk',
        '.vimeo.work',
        '.videoji.cn'
    ];
    for (const customDomain of customDomains){
        if (domain.endsWith(customDomain)) return domain;
    }
    return 'vimeo.com';
}
/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */ function $faa91f5616b3e685$var$getVimeoUrl() {
    let oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const id = oEmbedParameters.id;
    const url = oEmbedParameters.url;
    const idOrUrl = id || url;
    if (!idOrUrl) throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
    if ($faa91f5616b3e685$var$isInteger(idOrUrl)) return `https://vimeo.com/${idOrUrl}`;
    if ($faa91f5616b3e685$var$isVimeoUrl(idOrUrl)) return idOrUrl.replace('http:', 'https:');
    if (id) throw new TypeError(`\u{201C}${id}\u{201D} is not a valid video id.`);
    throw new TypeError(`\u{201C}${idOrUrl}\u{201D} is not a vimeo.com url.`);
}
/* eslint-disable max-params */ /**
 * A utility method for attaching and detaching event handlers
 *
 * @param {EventTarget} target
 * @param {string | string[]} eventName
 * @param {function} callback
 * @param {'addEventListener' | 'on'} onName
 * @param {'removeEventListener' | 'off'} offName
 * @return {{cancel: (function(): void)}}
 */ const $faa91f5616b3e685$var$subscribe = function(target, eventName, callback) {
    let onName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'addEventListener';
    let offName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'removeEventListener';
    const eventNames = typeof eventName === 'string' ? [
        eventName
    ] : eventName;
    eventNames.forEach((evName)=>{
        target[onName](evName, callback);
    });
    return {
        cancel: ()=>eventNames.forEach((evName)=>target[offName](evName, callback))
    };
};
/**
 * Find the iframe element that contains a specific source window
 *
 * @param {Window} sourceWindow The source window to find the iframe for
 * @param {Document} [doc=document] The document to search within
 * @return {HTMLIFrameElement|null} The iframe element if found, otherwise null
 */ function $faa91f5616b3e685$var$findIframeBySourceWindow(sourceWindow) {
    let doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    if (!sourceWindow || !doc || typeof doc.querySelectorAll !== 'function') return null;
    const iframes = doc.querySelectorAll('iframe');
    for(let i = 0; i < iframes.length; i++){
        if (iframes[i] && iframes[i].contentWindow === sourceWindow) return iframes[i];
    }
    return null;
}
const $faa91f5616b3e685$var$arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
const $faa91f5616b3e685$var$postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';
if (!$faa91f5616b3e685$var$isServerRuntime && (!$faa91f5616b3e685$var$arrayIndexOfSupport || !$faa91f5616b3e685$var$postMessageSupport)) throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
var $faa91f5616b3e685$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $faa91f5616b3e685$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */ (function(self1) {
    if (self1.WeakMap) return;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var hasDefine = Object.defineProperty && function() {
        try {
            // Avoid IE8's broken Object.defineProperty
            return Object.defineProperty({}, 'x', {
                value: 1
            }).x === 1;
        } catch (e) {}
    }();
    var defineProperty = function(object, name, value) {
        if (hasDefine) Object.defineProperty(object, name, {
            configurable: true,
            writable: true,
            value: value
        });
        else object[name] = value;
    };
    self1.WeakMap = function() {
        // ECMA-262 23.3 WeakMap Objects
        function WeakMap1() {
            if (this === void 0) throw new TypeError("Constructor WeakMap requires 'new'");
            defineProperty(this, '_id', genId('_WeakMap'));
            // ECMA-262 23.3.1.1 WeakMap([iterable])
            if (arguments.length > 0) // Currently, WeakMap `iterable` argument is not supported
            throw new TypeError('WeakMap iterable is not supported');
        }
        // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
        defineProperty(WeakMap1.prototype, 'delete', function(key) {
            checkInstance(this, 'delete');
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                delete key[this._id];
                return true;
            }
            return false;
        });
        // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
        defineProperty(WeakMap1.prototype, 'get', function(key) {
            checkInstance(this, 'get');
            if (!isObject(key)) return void 0;
            var entry = key[this._id];
            if (entry && entry[0] === key) return entry[1];
            return void 0;
        });
        // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
        defineProperty(WeakMap1.prototype, 'has', function(key) {
            checkInstance(this, 'has');
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) return true;
            return false;
        });
        // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
        defineProperty(WeakMap1.prototype, 'set', function(key, value) {
            checkInstance(this, 'set');
            if (!isObject(key)) throw new TypeError('Invalid value used as weak map key');
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                entry[1] = value;
                return this;
            }
            defineProperty(key, this._id, [
                key,
                value
            ]);
            return this;
        });
        function checkInstance(x, methodName) {
            if (!isObject(x) || !hasOwnProperty.call(x, '_id')) throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
        }
        function genId(prefix) {
            return prefix + '_' + rand() + '.' + rand();
        }
        function rand() {
            return Math.random().toString().substring(2);
        }
        defineProperty(WeakMap1, '_polyfill', true);
        return WeakMap1;
    }();
    function isObject(x) {
        return Object(x) === x;
    }
})(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $faa91f5616b3e685$var$commonjsGlobal !== 'undefined' ? $faa91f5616b3e685$var$commonjsGlobal : $faa91f5616b3e685$var$commonjsGlobal);
var $faa91f5616b3e685$var$npo_src = $faa91f5616b3e685$var$createCommonjsModule(function(module) {
    /*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/ (function UMD(name, context, definition) {
        // special form of UMD for polyfilling across evironments
        context[name] = context[name] || definition();
        if (module.exports) module.exports = context[name];
    })("Promise", typeof $faa91f5616b3e685$var$commonjsGlobal != "undefined" ? $faa91f5616b3e685$var$commonjsGlobal : $faa91f5616b3e685$var$commonjsGlobal, function DEF() {
        var builtInProp, cycle, scheduling_queue, ToString = Object.prototype.toString, timer = typeof setImmediate != "undefined" ? function timer(fn) {
            return setImmediate(fn);
        } : setTimeout;
        // dammit, IE8.
        try {
            Object.defineProperty({}, "x", {});
            builtInProp = function builtInProp(obj, name, val, config) {
                return Object.defineProperty(obj, name, {
                    value: val,
                    writable: true,
                    configurable: config !== false
                });
            };
        } catch (err) {
            builtInProp = function builtInProp(obj, name, val) {
                obj[name] = val;
                return obj;
            };
        }
        // Note: using a queue instead of array for efficiency
        scheduling_queue = function Queue() {
            var first, last, item;
            function Item(fn, self1) {
                this.fn = fn;
                this.self = self1;
                this.next = void 0;
            }
            return {
                add: function add(fn, self1) {
                    item = new Item(fn, self1);
                    if (last) last.next = item;
                    else first = item;
                    last = item;
                    item = void 0;
                },
                drain: function drain() {
                    var f = first;
                    first = last = cycle = void 0;
                    while(f){
                        f.fn.call(f.self);
                        f = f.next;
                    }
                }
            };
        }();
        function schedule(fn, self1) {
            scheduling_queue.add(fn, self1);
            if (!cycle) cycle = timer(scheduling_queue.drain);
        }
        // promise duck typing
        function isThenable(o) {
            var _then, o_type = typeof o;
            if (o != null && (o_type == "object" || o_type == "function")) _then = o.then;
            return typeof _then == "function" ? _then : false;
        }
        function notify() {
            for(var i = 0; i < this.chain.length; i++)notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
            this.chain.length = 0;
        }
        // NOTE: This is a separate function to isolate
        // the `try..catch` so that other code can be
        // optimized better
        function notifyIsolated(self1, cb, chain) {
            var ret, _then;
            try {
                if (cb === false) chain.reject(self1.msg);
                else {
                    if (cb === true) ret = self1.msg;
                    else ret = cb.call(void 0, self1.msg);
                    if (ret === chain.promise) chain.reject(TypeError("Promise-chain cycle"));
                    else if (_then = isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
                    else chain.resolve(ret);
                }
            } catch (err) {
                chain.reject(err);
            }
        }
        function resolve(msg) {
            var _then, self1 = this;
            // already triggered?
            if (self1.triggered) return;
            self1.triggered = true;
            // unwrap
            if (self1.def) self1 = self1.def;
            try {
                if (_then = isThenable(msg)) schedule(function() {
                    var def_wrapper = new MakeDefWrapper(self1);
                    try {
                        _then.call(msg, function $resolve$() {
                            resolve.apply(def_wrapper, arguments);
                        }, function $reject$() {
                            reject.apply(def_wrapper, arguments);
                        });
                    } catch (err) {
                        reject.call(def_wrapper, err);
                    }
                });
                else {
                    self1.msg = msg;
                    self1.state = 1;
                    if (self1.chain.length > 0) schedule(notify, self1);
                }
            } catch (err) {
                reject.call(new MakeDefWrapper(self1), err);
            }
        }
        function reject(msg) {
            var self1 = this;
            // already triggered?
            if (self1.triggered) return;
            self1.triggered = true;
            // unwrap
            if (self1.def) self1 = self1.def;
            self1.msg = msg;
            self1.state = 2;
            if (self1.chain.length > 0) schedule(notify, self1);
        }
        function iteratePromises(Constructor, arr, resolver, rejecter) {
            for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
                Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
                    resolver(idx, msg);
                }, rejecter);
            })(idx);
        }
        function MakeDefWrapper(self1) {
            this.def = self1;
            this.triggered = false;
        }
        function MakeDef(self1) {
            this.promise = self1;
            this.state = 0;
            this.triggered = false;
            this.chain = [];
            this.msg = void 0;
        }
        function Promise1(executor) {
            if (typeof executor != "function") throw TypeError("Not a function");
            if (this.__NPO__ !== 0) throw TypeError("Not a promise");
            // instance shadowing the inherited "brand"
            // to signal an already "initialized" promise
            this.__NPO__ = 1;
            var def = new MakeDef(this);
            this["then"] = function then(success, failure) {
                var o = {
                    success: typeof success == "function" ? success : true,
                    failure: typeof failure == "function" ? failure : false
                };
                // Note: `then(..)` itself can be borrowed to be used against
                // a different promise constructor for making the chained promise,
                // by substituting a different `this` binding.
                o.promise = new this.constructor(function extractChain(resolve, reject) {
                    if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                    o.resolve = resolve;
                    o.reject = reject;
                });
                def.chain.push(o);
                if (def.state !== 0) schedule(notify, def);
                return o.promise;
            };
            this["catch"] = function $catch$(failure) {
                return this.then(void 0, failure);
            };
            try {
                executor.call(void 0, function publicResolve(msg) {
                    resolve.call(def, msg);
                }, function publicReject(msg) {
                    reject.call(def, msg);
                });
            } catch (err) {
                reject.call(def, err);
            }
        }
        var PromisePrototype = builtInProp({}, "constructor", Promise1, /*configurable=*/ false);
        // Note: Android 4 cannot use `Object.defineProperty(..)` here
        Promise1.prototype = PromisePrototype;
        // built-in "brand" to signal an "uninitialized" promise
        builtInProp(PromisePrototype, "__NPO__", 0, /*configurable=*/ false);
        builtInProp(Promise1, "resolve", function Promise$resolve(msg) {
            var Constructor = this;
            // spec mandated checks
            // note: best "isPromise" check that's practical for now
            if (msg && typeof msg == "object" && msg.__NPO__ === 1) return msg;
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                resolve(msg);
            });
        });
        builtInProp(Promise1, "reject", function Promise$reject(msg) {
            return new this(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                reject(msg);
            });
        });
        builtInProp(Promise1, "all", function Promise$all(arr) {
            var Constructor = this;
            // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            if (arr.length === 0) return Constructor.resolve([]);
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                var len = arr.length, msgs = Array(len), count = 0;
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    msgs[idx] = msg;
                    if (++count === len) resolve(msgs);
                }, reject);
            });
        });
        builtInProp(Promise1, "race", function Promise$race(arr) {
            var Constructor = this;
            // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    resolve(msg);
                }, reject);
            });
        });
        return Promise1;
    });
});
/**
 * @module lib/callbacks
 */ const $faa91f5616b3e685$var$callbackMap = new WeakMap();
/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */ function $faa91f5616b3e685$var$storeCallback(player, name, callback) {
    const playerCallbacks = $faa91f5616b3e685$var$callbackMap.get(player.element) || {};
    if (!(name in playerCallbacks)) playerCallbacks[name] = [];
    playerCallbacks[name].push(callback);
    $faa91f5616b3e685$var$callbackMap.set(player.element, playerCallbacks);
}
/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */ function $faa91f5616b3e685$var$getCallbacks(player, name) {
    const playerCallbacks = $faa91f5616b3e685$var$callbackMap.get(player.element) || {};
    return playerCallbacks[name] || [];
}
/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */ function $faa91f5616b3e685$var$removeCallback(player, name, callback) {
    const playerCallbacks = $faa91f5616b3e685$var$callbackMap.get(player.element) || {};
    if (!playerCallbacks[name]) return true;
    // If no callback is passed, remove all callbacks for the event
    if (!callback) {
        playerCallbacks[name] = [];
        $faa91f5616b3e685$var$callbackMap.set(player.element, playerCallbacks);
        return true;
    }
    const index = playerCallbacks[name].indexOf(callback);
    if (index !== -1) playerCallbacks[name].splice(index, 1);
    $faa91f5616b3e685$var$callbackMap.set(player.element, playerCallbacks);
    return playerCallbacks[name] && playerCallbacks[name].length === 0;
}
/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */ function $faa91f5616b3e685$var$shiftCallbacks(player, name) {
    const playerCallbacks = $faa91f5616b3e685$var$getCallbacks(player, name);
    if (playerCallbacks.length < 1) return false;
    const callback = playerCallbacks.shift();
    $faa91f5616b3e685$var$removeCallback(player, name, callback);
    return callback;
}
/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */ function $faa91f5616b3e685$var$swapCallbacks(oldElement, newElement) {
    const playerCallbacks = $faa91f5616b3e685$var$callbackMap.get(oldElement);
    $faa91f5616b3e685$var$callbackMap.set(newElement, playerCallbacks);
    $faa91f5616b3e685$var$callbackMap.delete(oldElement);
}
/**
 * @module lib/postmessage
 */ /**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */ function $faa91f5616b3e685$var$parseMessageData(data) {
    if (typeof data === 'string') try {
        data = JSON.parse(data);
    } catch (error) {
        // If the message cannot be parsed, throw the error as a warning
        console.warn(error);
        return {};
    }
    return data;
}
/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {string|number|object|Array|undefined} params The parameters to send to the player.
 * @return {void}
 */ function $faa91f5616b3e685$var$postMessage(player, method, params) {
    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) return;
    let message = {
        method: method
    };
    if (params !== undefined) message.value = params;
    // IE 8 and 9 do not support passing messages, so stringify them
    const ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));
    if (ieVersion >= 8 && ieVersion < 10) message = JSON.stringify(message);
    player.element.contentWindow.postMessage(message, player.origin);
}
/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */ function $faa91f5616b3e685$var$processData(player, data) {
    data = $faa91f5616b3e685$var$parseMessageData(data);
    let callbacks = [];
    let param;
    if (data.event) {
        if (data.event === 'error') {
            const promises = $faa91f5616b3e685$var$getCallbacks(player, data.data.method);
            promises.forEach((promise)=>{
                const error = new Error(data.data.message);
                error.name = data.data.name;
                promise.reject(error);
                $faa91f5616b3e685$var$removeCallback(player, data.data.method, promise);
            });
        }
        callbacks = $faa91f5616b3e685$var$getCallbacks(player, `event:${data.event}`);
        param = data.data;
    } else if (data.method) {
        const callback = $faa91f5616b3e685$var$shiftCallbacks(player, data.method);
        if (callback) {
            callbacks.push(callback);
            param = data.value;
        }
    }
    callbacks.forEach((callback)=>{
        try {
            if (typeof callback === 'function') {
                callback.call(player, param);
                return;
            }
            callback.resolve(param);
        } catch (e) {
        // empty
        }
    });
}
/**
 * @module lib/embed
 */ const $faa91f5616b3e685$var$oEmbedParameters = [
    'airplay',
    'audio_tracks',
    'audiotrack',
    'autopause',
    'autoplay',
    'background',
    'byline',
    'cc',
    'chapter_id',
    'chapters',
    'chromecast',
    'color',
    'colors',
    'controls',
    'disable_context_menu',
    'dnt',
    'end_time',
    'fullscreen',
    'height',
    'id',
    'initial_quality',
    'interactive_params',
    'keyboard',
    'loop',
    'maxheight',
    'max_quality',
    'maxwidth',
    'min_quality',
    'muted',
    'play_button_position',
    'playsinline',
    'portrait',
    'preload',
    'progress_bar',
    'quality',
    'quality_selector',
    'responsive',
    'skipping_forward',
    'speed',
    'start_time',
    'texttrack',
    'thumbnail_id',
    'title',
    'transcript',
    'transparent',
    'unmute_button',
    'url',
    'vimeo_logo',
    'volume',
    'watch_full_video',
    'width'
];
/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */ function $faa91f5616b3e685$var$getOEmbedParameters(element) {
    let defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $faa91f5616b3e685$var$oEmbedParameters.reduce((params, param)=>{
        const value = element.getAttribute(`data-vimeo-${param}`);
        if (value || value === '') params[param] = value === '' ? 1 : value;
        return params;
    }, defaults);
}
/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */ function $faa91f5616b3e685$var$createEmbed(_ref, element) {
    let { html: html } = _ref;
    if (!element) throw new TypeError('An element must be provided');
    if (element.getAttribute('data-vimeo-initialized') !== null) return element.querySelector('iframe');
    const div = document.createElement('div');
    div.innerHTML = html;
    element.appendChild(div.firstChild);
    element.setAttribute('data-vimeo-initialized', 'true');
    return element.querySelector('iframe');
}
/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */ function $faa91f5616b3e685$var$getOEmbedData(videoUrl) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let element = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise((resolve, reject)=>{
        if (!$faa91f5616b3e685$var$isVimeoUrl(videoUrl)) throw new TypeError(`\u{201C}${videoUrl}\u{201D} is not a vimeo.com url.`);
        const domain = $faa91f5616b3e685$var$getOembedDomain(videoUrl);
        let url = `https://${domain}/api/oembed.json?url=${encodeURIComponent(videoUrl)}`;
        for(const param in params)if (params.hasOwnProperty(param)) url += `&${param}=${encodeURIComponent(params[param])}`;
        const xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onload = function() {
            if (xhr.status === 404) {
                reject(new Error(`\u{201C}${videoUrl}\u{201D} was not found.`));
                return;
            }
            if (xhr.status === 403) {
                reject(new Error(`\u{201C}${videoUrl}\u{201D} is not embeddable.`));
                return;
            }
            try {
                const json = JSON.parse(xhr.responseText);
                // Check api response for 403 on oembed
                if (json.domain_status_code === 403) {
                    // We still want to create the embed to give users visual feedback
                    $faa91f5616b3e685$var$createEmbed(json, element);
                    reject(new Error(`\u{201C}${videoUrl}\u{201D} is not embeddable.`));
                    return;
                }
                resolve(json);
            } catch (error) {
                reject(error);
            }
        };
        xhr.onerror = function() {
            const status = xhr.status ? ` (${xhr.status})` : '';
            reject(new Error(`There was an error fetching the embed code from Vimeo${status}.`));
        };
        xhr.send();
    });
}
/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $faa91f5616b3e685$var$initializeEmbeds() {
    let parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    const elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));
    const handleError = (error)=>{
        if ('console' in window && console.error) console.error(`There was an error creating an embed: ${error}`);
    };
    elements.forEach((element)=>{
        try {
            // Skip any that have data-vimeo-defer
            if (element.getAttribute('data-vimeo-defer') !== null) return;
            const params = $faa91f5616b3e685$var$getOEmbedParameters(element);
            const url = $faa91f5616b3e685$var$getVimeoUrl(params);
            $faa91f5616b3e685$var$getOEmbedData(url, params, element).then((data)=>{
                return $faa91f5616b3e685$var$createEmbed(data, element);
            }).catch(handleError);
        } catch (error) {
            handleError(error);
        }
    });
}
/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $faa91f5616b3e685$var$resizeEmbeds() {
    let parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    // Prevent execution if users include the player.js script multiple times.
    if (window.VimeoPlayerResizeEmbeds_) return;
    window.VimeoPlayerResizeEmbeds_ = true;
    const onMessage = (event)=>{
        if (!$faa91f5616b3e685$var$isVimeoUrl(event.origin)) return;
        // 'spacechange' is fired only on embeds with cards
        if (!event.data || event.data.event !== 'spacechange') return;
        const senderIFrame = event.source ? $faa91f5616b3e685$var$findIframeBySourceWindow(event.source, parent) : null;
        if (senderIFrame) {
            // Change padding-bottom of the enclosing div to accommodate
            // card carousel without distorting aspect ratio
            const space = senderIFrame.parentElement;
            space.style.paddingBottom = `${event.data.data[0].bottom}px`;
        }
    };
    window.addEventListener('message', onMessage);
}
/**
 * Add chapters to existing metadata for Google SEO
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $faa91f5616b3e685$var$initAppendVideoMetadata() {
    let parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoSeoMetadataAppended) return;
    window.VimeoSeoMetadataAppended = true;
    const onMessage = (event)=>{
        if (!$faa91f5616b3e685$var$isVimeoUrl(event.origin)) return;
        const data = $faa91f5616b3e685$var$parseMessageData(event.data);
        if (!data || data.event !== 'ready') return;
        const senderIFrame = event.source ? $faa91f5616b3e685$var$findIframeBySourceWindow(event.source, parent) : null;
        // Initiate appendVideoMetadata if iframe is a Vimeo embed
        if (senderIFrame && $faa91f5616b3e685$var$isVimeoEmbed(senderIFrame.src)) {
            const player = new $faa91f5616b3e685$var$Player(senderIFrame);
            player.callMethod('appendVideoMetadata', window.location.href);
        }
    };
    window.addEventListener('message', onMessage);
}
/**
 * Seek to time indicated by vimeo_t query parameter if present in URL
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $faa91f5616b3e685$var$checkUrlTimeParam() {
    let parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoCheckedUrlTimeParam) return;
    window.VimeoCheckedUrlTimeParam = true;
    const handleError = (error)=>{
        if ('console' in window && console.error) console.error(`There was an error getting video Id: ${error}`);
    };
    const onMessage = (event)=>{
        if (!$faa91f5616b3e685$var$isVimeoUrl(event.origin)) return;
        const data = $faa91f5616b3e685$var$parseMessageData(event.data);
        if (!data || data.event !== 'ready') return;
        const senderIFrame = event.source ? $faa91f5616b3e685$var$findIframeBySourceWindow(event.source, parent) : null;
        if (senderIFrame && $faa91f5616b3e685$var$isVimeoEmbed(senderIFrame.src)) {
            const player = new $faa91f5616b3e685$var$Player(senderIFrame);
            player.getVideoId().then((videoId)=>{
                const matches = new RegExp(`[?&]vimeo_t_${videoId}=([^&#]*)`).exec(window.location.href);
                if (matches && matches[1]) {
                    const sec = decodeURI(matches[1]);
                    player.setCurrentTime(sec);
                }
                return;
            }).catch(handleError);
        }
    };
    window.addEventListener('message', onMessage);
}
/**
 * Updates iframe embeds to support DRM content playback by adding the 'encrypted-media' permission
 * to the iframe's allow attribute when DRM initialization fails. This function acts as a fallback
 * mechanism to enable playback of DRM-protected content in embeds that weren't properly configured.
 *
 * @return {void}
 */ function $faa91f5616b3e685$var$updateDRMEmbeds() {
    if (window.VimeoDRMEmbedsUpdated) return;
    window.VimeoDRMEmbedsUpdated = true;
    /**
   * Handle message events for DRM initialization failures
   * @param {MessageEvent} event - The message event from the iframe
   */ const onMessage = (event)=>{
        if (!$faa91f5616b3e685$var$isVimeoUrl(event.origin)) return;
        const data = $faa91f5616b3e685$var$parseMessageData(event.data);
        if (!data || data.event !== 'drminitfailed') return;
        const senderIFrame = event.source ? $faa91f5616b3e685$var$findIframeBySourceWindow(event.source) : null;
        if (!senderIFrame) return;
        const currentAllow = senderIFrame.getAttribute('allow') || '';
        const allowSupportsDRM = currentAllow.includes('encrypted-media');
        if (!allowSupportsDRM) {
            // For DRM playback to successfully occur, the iframe `allow` attribute must include 'encrypted-media'.
            // If the video requires DRM but doesn't have the attribute, we try to add on behalf of the embed owner
            // as a temporary measure to enable playback until they're able to update their embeds.
            senderIFrame.setAttribute('allow', `${currentAllow}; encrypted-media`);
            const currentUrl = new URL(senderIFrame.getAttribute('src'));
            // Adding this forces the embed to reload once `allow` has been updated with `encrypted-media`.
            currentUrl.searchParams.set('forcereload', 'drm');
            senderIFrame.setAttribute('src', currentUrl.toString());
            return;
        }
    };
    window.addEventListener('message', onMessage);
}
/* MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Terms */ function $faa91f5616b3e685$var$initializeScreenfull() {
    const fn = function() {
        let val;
        const fnMap = [
            [
                'requestFullscreen',
                'exitFullscreen',
                'fullscreenElement',
                'fullscreenEnabled',
                'fullscreenchange',
                'fullscreenerror'
            ],
            // New WebKit
            [
                'webkitRequestFullscreen',
                'webkitExitFullscreen',
                'webkitFullscreenElement',
                'webkitFullscreenEnabled',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            // Old WebKit
            [
                'webkitRequestFullScreen',
                'webkitCancelFullScreen',
                'webkitCurrentFullScreenElement',
                'webkitCancelFullScreen',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            [
                'mozRequestFullScreen',
                'mozCancelFullScreen',
                'mozFullScreenElement',
                'mozFullScreenEnabled',
                'mozfullscreenchange',
                'mozfullscreenerror'
            ],
            [
                'msRequestFullscreen',
                'msExitFullscreen',
                'msFullscreenElement',
                'msFullscreenEnabled',
                'MSFullscreenChange',
                'MSFullscreenError'
            ]
        ];
        let i = 0;
        const l = fnMap.length;
        const ret = {};
        for(; i < l; i++){
            val = fnMap[i];
            if (val && val[1] in document) {
                for(i = 0; i < val.length; i++)ret[fnMap[0][i]] = val[i];
                return ret;
            }
        }
        return false;
    }();
    const eventNameMap = {
        fullscreenchange: fn.fullscreenchange,
        fullscreenerror: fn.fullscreenerror
    };
    const screenfull = {
        request (element) {
            return new Promise((resolve, reject)=>{
                const onFullScreenEntered = function() {
                    screenfull.off('fullscreenchange', onFullScreenEntered);
                    resolve();
                };
                screenfull.on('fullscreenchange', onFullScreenEntered);
                element = element || document.documentElement;
                const returnPromise = element[fn.requestFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
            });
        },
        exit () {
            return new Promise((resolve, reject)=>{
                if (!screenfull.isFullscreen) {
                    resolve();
                    return;
                }
                const onFullScreenExit = function() {
                    screenfull.off('fullscreenchange', onFullScreenExit);
                    resolve();
                };
                screenfull.on('fullscreenchange', onFullScreenExit);
                const returnPromise = document[fn.exitFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
            });
        },
        on (event, callback) {
            const eventName = eventNameMap[event];
            if (eventName) document.addEventListener(eventName, callback);
        },
        off (event, callback) {
            const eventName = eventNameMap[event];
            if (eventName) document.removeEventListener(eventName, callback);
        }
    };
    Object.defineProperties(screenfull, {
        isFullscreen: {
            get () {
                return Boolean(document[fn.fullscreenElement]);
            }
        },
        element: {
            enumerable: true,
            get () {
                return document[fn.fullscreenElement];
            }
        },
        isEnabled: {
            enumerable: true,
            get () {
                // Coerce to boolean in case of old WebKit
                return Boolean(document[fn.fullscreenEnabled]);
            }
        }
    });
    return screenfull;
}
/** @typedef {import('./timing-src-connector.types').PlayerControls} PlayerControls */ /** @typedef {import('timing-object').ITimingObject} TimingObject */ /** @typedef {import('./timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */ /** @typedef {(msg: string) => any} Logger */ /** @typedef {import('timing-object').TConnectionState} TConnectionState */ /**
 * @type {TimingSrcConnectorOptions}
 *
 * For details on these properties and their effects, see the typescript definition referenced above.
 */ const $faa91f5616b3e685$var$defaultOptions = {
    role: 'viewer',
    autoPlayMuted: true,
    allowedDrift: 0.3,
    maxAllowedDrift: 1,
    minCheckInterval: 0.1,
    maxRateAdjustment: 0.2,
    maxTimeToCatchUp: 1
};
/**
 * There's a proposed W3C spec for the Timing Object which would introduce a new set of APIs that would simplify time-synchronization tasks for browser applications.
 *
 * Proposed spec: https://webtiming.github.io/timingobject/
 * V3 Spec: https://timingsrc.readthedocs.io/en/latest/
 * Demuxed talk: https://www.youtube.com/watch?v=cZSjDaGDmX8
 *
 * This class makes it easy to connect Vimeo.Player to a provided TimingObject via Vimeo.Player.setTimingSrc(myTimingObject, options) and the synchronization will be handled automatically.
 *
 * There are 5 general responsibilities in TimingSrcConnector:
 *
 * 1. `updatePlayer()` which sets the player's currentTime, playbackRate and pause/play state based on current state of the TimingObject.
 * 2. `updateTimingObject()` which sets the TimingObject's position and velocity from the player's state.
 * 3. `playerUpdater` which listens for change events on the TimingObject and will respond by calling updatePlayer.
 * 4. `timingObjectUpdater` which listens to the player events of seeked, play and pause and will respond by calling `updateTimingObject()`.
 * 5. `maintainPlaybackPosition` this is code that constantly monitors the player to make sure it's always in sync with the TimingObject. This is needed because videos will generally not play with precise time accuracy and there will be some drift which becomes more noticeable over longer periods (as noted in the timing-object spec). More details on this method below.
 */ class $faa91f5616b3e685$var$TimingSrcConnector extends EventTarget {
    logger;
    /**
   * @param {PlayerControls} player
   * @param {TimingObject} timingObject
   * @param {TimingSrcConnectorOptions} options
   * @param {Logger} logger
   */ constructor(player, timingObject){
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let logger = arguments.length > 3 ? arguments[3] : undefined;
        super();
        this.logger = logger;
        this.init(timingObject, player, {
            ...$faa91f5616b3e685$var$defaultOptions,
            ...options
        });
    }
    disconnect() {
        this.dispatchEvent(new Event('disconnect'));
    }
    /**
   * @param {TimingObject} timingObject
   * @param {PlayerControls} player
   * @param {TimingSrcConnectorOptions} options
   * @return {Promise<void>}
   */ async init(timingObject, player, options) {
        await this.waitForTOReadyState(timingObject, 'open');
        if (options.role === 'viewer') {
            await this.updatePlayer(timingObject, player, options);
            const playerUpdater = $faa91f5616b3e685$var$subscribe(timingObject, 'change', ()=>this.updatePlayer(timingObject, player, options));
            const positionSync = this.maintainPlaybackPosition(timingObject, player, options);
            this.addEventListener('disconnect', ()=>{
                positionSync.cancel();
                playerUpdater.cancel();
            });
        } else {
            await this.updateTimingObject(timingObject, player);
            const timingObjectUpdater = $faa91f5616b3e685$var$subscribe(player, [
                'seeked',
                'play',
                'pause',
                'ratechange'
            ], ()=>this.updateTimingObject(timingObject, player), 'on', 'off');
            this.addEventListener('disconnect', ()=>timingObjectUpdater.cancel());
        }
    }
    /**
   * Sets the TimingObject's state to reflect that of the player
   *
   * @param {TimingObject} timingObject
   * @param {PlayerControls} player
   * @return {Promise<void>}
   */ async updateTimingObject(timingObject, player) {
        const [position, isPaused, playbackRate] = await Promise.all([
            player.getCurrentTime(),
            player.getPaused(),
            player.getPlaybackRate()
        ]);
        timingObject.update({
            position: position,
            velocity: isPaused ? 0 : playbackRate
        });
    }
    /**
   * Sets the player's timing state to reflect that of the TimingObject
   *
   * @param {TimingObject} timingObject
   * @param {PlayerControls} player
   * @param {TimingSrcConnectorOptions} options
   * @return {Promise<void>}
   */ async updatePlayer(timingObject, player, options) {
        const { position: position, velocity: velocity } = timingObject.query();
        if (typeof position === 'number') player.setCurrentTime(position);
        if (typeof velocity === 'number') {
            if (velocity === 0) {
                if (await player.getPaused() === false) player.pause();
            } else if (velocity > 0) {
                if (await player.getPaused() === true) {
                    await player.play().catch(async (err)=>{
                        if (err.name === 'NotAllowedError' && options.autoPlayMuted) {
                            await player.setMuted(true);
                            await player.play().catch((err2)=>console.error('Couldn\'t play the video from TimingSrcConnector. Error:', err2));
                        }
                    });
                    this.updatePlayer(timingObject, player, options);
                }
                if (await player.getPlaybackRate() !== velocity) player.setPlaybackRate(velocity);
            }
        }
    }
    /**
   * Since video players do not play with 100% time precision, we need to closely monitor
   * our player to be sure it remains in sync with the TimingObject.
   *
   * If out of sync, we use the current conditions and the options provided to determine
   * whether to re-sync via setting currentTime or adjusting the playbackRate
   *
   * @param {TimingObject} timingObject
   * @param {PlayerControls} player
   * @param {TimingSrcConnectorOptions} options
   * @return {{cancel: (function(): void)}}
   */ maintainPlaybackPosition(timingObject, player, options) {
        const { allowedDrift: allowedDrift, maxAllowedDrift: maxAllowedDrift, minCheckInterval: minCheckInterval, maxRateAdjustment: maxRateAdjustment, maxTimeToCatchUp: maxTimeToCatchUp } = options;
        const syncInterval = Math.min(maxTimeToCatchUp, Math.max(minCheckInterval, maxAllowedDrift)) * 1000;
        const check = async ()=>{
            if (timingObject.query().velocity === 0 || await player.getPaused() === true) return;
            const diff = timingObject.query().position - await player.getCurrentTime();
            const diffAbs = Math.abs(diff);
            this.log(`Drift: ${diff}`);
            if (diffAbs > maxAllowedDrift) {
                await this.adjustSpeed(player, 0);
                player.setCurrentTime(timingObject.query().position);
                this.log('Resync by currentTime');
            } else if (diffAbs > allowedDrift) {
                const min = diffAbs / maxTimeToCatchUp;
                const max = maxRateAdjustment;
                const adjustment = min < max ? (max - min) / 2 : max;
                await this.adjustSpeed(player, adjustment * Math.sign(diff));
                this.log('Resync by playbackRate');
            }
        };
        const interval = setInterval(()=>check(), syncInterval);
        return {
            cancel: ()=>clearInterval(interval)
        };
    }
    /**
   * @param {string} msg
   */ log(msg) {
        this.logger?.(`TimingSrcConnector: ${msg}`);
    }
    speedAdjustment = 0;
    /**
   * @param {PlayerControls} player
   * @param {number} newAdjustment
   * @return {Promise<void>}
   */ adjustSpeed = async (player, newAdjustment)=>{
        if (this.speedAdjustment === newAdjustment) return;
        const newPlaybackRate = await player.getPlaybackRate() - this.speedAdjustment + newAdjustment;
        this.log(`New playbackRate:  ${newPlaybackRate}`);
        await player.setPlaybackRate(newPlaybackRate);
        this.speedAdjustment = newAdjustment;
    };
    /**
   * @param {TimingObject} timingObject
   * @param {TConnectionState} state
   * @return {Promise<void>}
   */ waitForTOReadyState(timingObject, state) {
        return new Promise((resolve)=>{
            const check = ()=>{
                if (timingObject.readyState === state) resolve();
                else timingObject.addEventListener('readystatechange', check, {
                    once: true
                });
            };
            check();
        });
    }
}
const $faa91f5616b3e685$var$playerMap = new WeakMap();
const $faa91f5616b3e685$var$readyMap = new WeakMap();
let $faa91f5616b3e685$var$screenfull = {};
class $faa91f5616b3e685$var$Player {
    /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */ constructor(element){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        /* global jQuery */ if (window.jQuery && element instanceof jQuery) {
            if (element.length > 1 && window.console && console.warn) console.warn('A jQuery object with multiple elements was passed, using the first element.');
            element = element[0];
        }
        // Find an element by ID
        if (typeof document !== 'undefined' && typeof element === 'string') element = document.getElementById(element);
        // Not an element!
        if (!$faa91f5616b3e685$var$isDomElement(element)) throw new TypeError('You must pass either a valid element or a valid id.');
        // Already initialized an embed in this div, so grab the iframe
        if (element.nodeName !== 'IFRAME') {
            const iframe = element.querySelector('iframe');
            if (iframe) element = iframe;
        }
        // iframe url is not a Vimeo url
        if (element.nodeName === 'IFRAME' && !$faa91f5616b3e685$var$isVimeoUrl(element.getAttribute('src') || '')) throw new Error("The player element passed isn\u2019t a Vimeo embed.");
        // If there is already a player object in the map, return that
        if ($faa91f5616b3e685$var$playerMap.has(element)) return $faa91f5616b3e685$var$playerMap.get(element);
        this._window = element.ownerDocument.defaultView;
        this.element = element;
        this.origin = '*';
        const readyPromise = new $faa91f5616b3e685$var$npo_src((resolve, reject)=>{
            this._onMessage = (event)=>{
                if (!$faa91f5616b3e685$var$isVimeoUrl(event.origin) || this.element.contentWindow !== event.source) return;
                if (this.origin === '*') this.origin = event.origin;
                const data = $faa91f5616b3e685$var$parseMessageData(event.data);
                const isError = data && data.event === 'error';
                const isReadyError = isError && data.data && data.data.method === 'ready';
                if (isReadyError) {
                    const error = new Error(data.data.message);
                    error.name = data.data.name;
                    reject(error);
                    return;
                }
                const isReadyEvent = data && data.event === 'ready';
                const isPingResponse = data && data.method === 'ping';
                if (isReadyEvent || isPingResponse) {
                    this.element.setAttribute('data-ready', 'true');
                    resolve();
                    return;
                }
                $faa91f5616b3e685$var$processData(this, data);
            };
            this._window.addEventListener('message', this._onMessage);
            if (this.element.nodeName !== 'IFRAME') {
                const params = $faa91f5616b3e685$var$getOEmbedParameters(element, options);
                const url = $faa91f5616b3e685$var$getVimeoUrl(params);
                $faa91f5616b3e685$var$getOEmbedData(url, params, element).then((data)=>{
                    const iframe = $faa91f5616b3e685$var$createEmbed(data, element);
                    // Overwrite element with the new iframe,
                    // but store reference to the original element
                    this.element = iframe;
                    this._originalElement = element;
                    $faa91f5616b3e685$var$swapCallbacks(element, iframe);
                    $faa91f5616b3e685$var$playerMap.set(this.element, this);
                    return data;
                }).catch(reject);
            }
        });
        // Store a copy of this Player in the map
        $faa91f5616b3e685$var$readyMap.set(this, readyPromise);
        $faa91f5616b3e685$var$playerMap.set(this.element, this);
        // Send a ping to the iframe so the ready promise will be resolved if
        // the player is already ready.
        if (this.element.nodeName === 'IFRAME') $faa91f5616b3e685$var$postMessage(this, 'ping');
        if ($faa91f5616b3e685$var$screenfull.isEnabled) {
            const exitFullscreen = ()=>$faa91f5616b3e685$var$screenfull.exit();
            this.fullscreenchangeHandler = ()=>{
                if ($faa91f5616b3e685$var$screenfull.isFullscreen) $faa91f5616b3e685$var$storeCallback(this, 'event:exitFullscreen', exitFullscreen);
                else $faa91f5616b3e685$var$removeCallback(this, 'event:exitFullscreen', exitFullscreen);
                // eslint-disable-next-line
                this.ready().then(()=>{
                    $faa91f5616b3e685$var$postMessage(this, 'fullscreenchange', $faa91f5616b3e685$var$screenfull.isFullscreen);
                });
            };
            $faa91f5616b3e685$var$screenfull.on('fullscreenchange', this.fullscreenchangeHandler);
        }
        return this;
    }
    /**
   * Check to see if the URL is a Vimeo URL.
   *
   * @param {string} url The URL string.
   * @return {boolean}
   */ static isVimeoUrl(url) {
        return $faa91f5616b3e685$var$isVimeoUrl(url);
    }
    /**
   * Get a promise for a method.
   *
   * @param {string} name The API method to call.
   * @param {...(string|number|object|Array)} args Arguments to send via postMessage.
   * @return {Promise}
   */ callMethod(name) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (name === undefined || name === null) throw new TypeError('You must pass a method name.');
        return new $faa91f5616b3e685$var$npo_src((resolve, reject)=>{
            // We are storing the resolve/reject handlers to call later, so we
            // can’t return here.
            return this.ready().then(()=>{
                $faa91f5616b3e685$var$storeCallback(this, name, {
                    resolve: resolve,
                    reject: reject
                });
                if (args.length === 0) args = {};
                else if (args.length === 1) args = args[0];
                $faa91f5616b3e685$var$postMessage(this, name, args);
            }).catch(reject);
        });
    }
    /**
   * Get a promise for the value of a player property.
   *
   * @param {string} name The property name
   * @return {Promise}
   */ get(name) {
        return new $faa91f5616b3e685$var$npo_src((resolve, reject)=>{
            name = $faa91f5616b3e685$var$getMethodName(name, 'get');
            // We are storing the resolve/reject handlers to call later, so we
            // can’t return here.
            return this.ready().then(()=>{
                $faa91f5616b3e685$var$storeCallback(this, name, {
                    resolve: resolve,
                    reject: reject
                });
                $faa91f5616b3e685$var$postMessage(this, name);
            }).catch(reject);
        });
    }
    /**
   * Get a promise for setting the value of a player property.
   *
   * @param {string} name The API method to call.
   * @param {mixed} value The value to set.
   * @return {Promise}
   */ set(name, value) {
        return new $faa91f5616b3e685$var$npo_src((resolve, reject)=>{
            name = $faa91f5616b3e685$var$getMethodName(name, 'set');
            if (value === undefined || value === null) throw new TypeError('There must be a value to set.');
            // We are storing the resolve/reject handlers to call later, so we
            // can’t return here.
            return this.ready().then(()=>{
                $faa91f5616b3e685$var$storeCallback(this, name, {
                    resolve: resolve,
                    reject: reject
                });
                $faa91f5616b3e685$var$postMessage(this, name, value);
            }).catch(reject);
        });
    }
    /**
   * Add an event listener for the specified event. Will call the
   * callback with a single parameter, `data`, that contains the data for
   * that event.
   *
   * @param {string} eventName The name of the event.
   * @param {function(*)} callback The function to call when the event fires.
   * @return {void}
   */ on(eventName, callback) {
        if (!eventName) throw new TypeError('You must pass an event name.');
        if (!callback) throw new TypeError('You must pass a callback function.');
        if (typeof callback !== 'function') throw new TypeError('The callback must be a function.');
        const callbacks = $faa91f5616b3e685$var$getCallbacks(this, `event:${eventName}`);
        if (callbacks.length === 0) this.callMethod('addEventListener', eventName).catch(()=>{
        // Ignore the error. There will be an error event fired that
        // will trigger the error callback if they are listening.
        });
        $faa91f5616b3e685$var$storeCallback(this, `event:${eventName}`, callback);
    }
    /**
   * Remove an event listener for the specified event. Will remove all
   * listeners for that event if a `callback` isn’t passed, or only that
   * specific callback if it is passed.
   *
   * @param {string} eventName The name of the event.
   * @param {function} [callback] The specific callback to remove.
   * @return {void}
   */ off(eventName, callback) {
        if (!eventName) throw new TypeError('You must pass an event name.');
        if (callback && typeof callback !== 'function') throw new TypeError('The callback must be a function.');
        const lastCallback = $faa91f5616b3e685$var$removeCallback(this, `event:${eventName}`, callback);
        // If there are no callbacks left, remove the listener
        if (lastCallback) this.callMethod('removeEventListener', eventName).catch((e)=>{
        // Ignore the error. There will be an error event fired that
        // will trigger the error callback if they are listening.
        });
    }
    /**
   * A promise to load a new video.
   *
   * @promise LoadVideoPromise
   * @fulfill {number} The video with this id or url successfully loaded.
   * @reject {TypeError} The id was not a number.
   */ /**
   * Load a new video into this embed. The promise will be resolved if
   * the video is successfully loaded, or it will be rejected if it could
   * not be loaded.
   *
   * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
   * @return {LoadVideoPromise}
   */ loadVideo(options) {
        return this.callMethod('loadVideo', options);
    }
    /**
   * A promise to perform an action when the Player is ready.
   *
   * @todo document errors
   * @promise LoadVideoPromise
   * @fulfill {void}
   */ /**
   * Trigger a function when the player iframe has initialized. You do not
   * need to wait for `ready` to trigger to begin adding event listeners
   * or calling other methods.
   *
   * @return {ReadyPromise}
   */ ready() {
        const readyPromise = $faa91f5616b3e685$var$readyMap.get(this) || new $faa91f5616b3e685$var$npo_src((resolve, reject)=>{
            reject(new Error('Unknown player. Probably unloaded.'));
        });
        return $faa91f5616b3e685$var$npo_src.resolve(readyPromise);
    }
    /**
   * A promise to add a cue point to the player.
   *
   * @promise AddCuePointPromise
   * @fulfill {string} The id of the cue point to use for removeCuePoint.
   * @reject {RangeError} the time was less than 0 or greater than the
   *         video’s duration.
   * @reject {UnsupportedError} Cue points are not supported with the current
   *         player or browser.
   */ /**
   * Add a cue point to the player.
   *
   * @param {number} time The time for the cue point.
   * @param {object} [data] Arbitrary data to be returned with the cue point.
   * @return {AddCuePointPromise}
   */ addCuePoint(time) {
        let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.callMethod('addCuePoint', {
            time: time,
            data: data
        });
    }
    /**
   * A promise to remove a cue point from the player.
   *
   * @promise AddCuePointPromise
   * @fulfill {string} The id of the cue point that was removed.
   * @reject {InvalidCuePoint} The cue point with the specified id was not
   *         found.
   * @reject {UnsupportedError} Cue points are not supported with the current
   *         player or browser.
   */ /**
   * Remove a cue point from the video.
   *
   * @param {string} id The id of the cue point to remove.
   * @return {RemoveCuePointPromise}
   */ removeCuePoint(id) {
        return this.callMethod('removeCuePoint', id);
    }
    /**
   * A representation of a text track on a video.
   *
   * @typedef {Object} VimeoTextTrack
   * @property {string} language The ISO language code.
   * @property {string} kind The kind of track it is (captions or subtitles).
   * @property {string} label The human‐readable label for the track.
   */ /**
   * A promise to enable a text track.
   *
   * @promise EnableTextTrackPromise
   * @fulfill {VimeoTextTrack} The text track that was enabled.
   * @reject {InvalidTrackLanguageError} No track was available with the
   *         specified language.
   * @reject {InvalidTrackError} No track was available with the specified
   *         language and kind.
   */ /**
   * Enable the text track with the specified language, and optionally the
   * specified kind (captions or subtitles).
   *
   * When set via the API, the track language will not change the viewer’s
   * stored preference.
   *
   * @param {string} language The two‐letter language code.
   * @param {string} [kind] The kind of track to enable (captions or subtitles).
   * @param {boolean} [showing] Whether to enable display of closed captions for enabled text track within the player.
   * @return {EnableTextTrackPromise}
   */ enableTextTrack(language) {
        let kind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        let showing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        if (!language) throw new TypeError('You must pass a language.');
        return this.callMethod('enableTextTrack', {
            language: language,
            kind: kind,
            showing: showing
        });
    }
    /**
   * A promise to disable the active text track.
   *
   * @promise DisableTextTrackPromise
   * @fulfill {void} The track was disabled.
   */ /**
   * Disable the currently-active text track.
   *
   * @return {DisableTextTrackPromise}
   */ disableTextTrack() {
        return this.callMethod('disableTextTrack');
    }
    /** @typedef {import('../types/formats.js').VimeoAudioTrack} VimeoAudioTrack */ /** @typedef {import('../types/formats.js').AudioLanguage} AudioLanguage */ /** @typedef {import('../types/formats.js').AudioKind} AudioKind */ /**
   * A promise to enable an audio track.
   *
   * @promise SelectAudioTrackPromise
   * @fulfill {VimeoAudioTrack} The audio track that was enabled.
   * @reject {NoAudioTracksError} No audio exists for the video.
   * @reject {NoAlternateAudioTracksError} No alternate audio tracks exist for the video.
   * @reject {NoMatchingAudioTrackError} No track was available with the specified
   *         language and kind.
   */ /**
   * Enable the audio track with the specified language, and optionally the
   * specified kind (main, translation, descriptions, or commentary).
   *
   * When set via the API, the track language will not change the viewer’s
   * stored preference.
   *
   * @param {AudioLanguage} language The two‐letter language code.
   * @param {AudioKind} [kind] The kind of track to enable (main, translation, descriptions, commentary).
   * @return {SelectAudioTrackPromise}
   */ selectAudioTrack(language, kind) {
        if (!language) throw new TypeError('You must pass a language.');
        return this.callMethod('selectAudioTrack', {
            language: language,
            kind: kind
        });
    }
    /**
   * Enable the main audio track for the video.
   *
   * @return {SelectAudioTrackPromise}
   */ selectDefaultAudioTrack() {
        return this.callMethod('selectDefaultAudioTrack');
    }
    /**
   * A promise to pause the video.
   *
   * @promise PausePromise
   * @fulfill {void} The video was paused.
   */ /**
   * Pause the video if it’s playing.
   *
   * @return {PausePromise}
   */ pause() {
        return this.callMethod('pause');
    }
    /**
   * A promise to play the video.
   *
   * @promise PlayPromise
   * @fulfill {void} The video was played.
   */ /**
   * Play the video if it’s paused. **Note:** on iOS and some other
   * mobile devices, you cannot programmatically trigger play. Once the
   * viewer has tapped on the play button in the player, however, you
   * will be able to use this function.
   *
   * @return {PlayPromise}
   */ play() {
        return this.callMethod('play');
    }
    /**
   * Request that the player enters fullscreen.
   * @return {Promise}
   */ requestFullscreen() {
        if ($faa91f5616b3e685$var$screenfull.isEnabled) return $faa91f5616b3e685$var$screenfull.request(this.element);
        return this.callMethod('requestFullscreen');
    }
    /**
   * Request that the player exits fullscreen.
   * @return {Promise}
   */ exitFullscreen() {
        if ($faa91f5616b3e685$var$screenfull.isEnabled) return $faa91f5616b3e685$var$screenfull.exit();
        return this.callMethod('exitFullscreen');
    }
    /**
   * Returns true if the player is currently fullscreen.
   * @return {Promise}
   */ getFullscreen() {
        if ($faa91f5616b3e685$var$screenfull.isEnabled) return $faa91f5616b3e685$var$npo_src.resolve($faa91f5616b3e685$var$screenfull.isFullscreen);
        return this.get('fullscreen');
    }
    /**
   * Request that the player enters picture-in-picture.
   * @return {Promise}
   */ requestPictureInPicture() {
        return this.callMethod('requestPictureInPicture');
    }
    /**
   * Request that the player exits picture-in-picture.
   * @return {Promise}
   */ exitPictureInPicture() {
        return this.callMethod('exitPictureInPicture');
    }
    /**
   * Returns true if the player is currently picture-in-picture.
   * @return {Promise}
   */ getPictureInPicture() {
        return this.get('pictureInPicture');
    }
    /**
   * A promise to prompt the viewer to initiate remote playback.
   *
   * @promise RemotePlaybackPromptPromise
   * @fulfill {void}
   * @reject {NotFoundError} No remote playback device is available.
   */ /**
   * Request to prompt the user to initiate remote playback.
   *
   * @return {RemotePlaybackPromptPromise}
   */ remotePlaybackPrompt() {
        return this.callMethod('remotePlaybackPrompt');
    }
    /**
   * A promise to unload the video.
   *
   * @promise UnloadPromise
   * @fulfill {void} The video was unloaded.
   */ /**
   * Return the player to its initial state.
   *
   * @return {UnloadPromise}
   */ unload() {
        return this.callMethod('unload');
    }
    /**
   * Cleanup the player and remove it from the DOM
   *
   * It won't be usable and a new one should be constructed
   *  in order to do any operations.
   *
   * @return {Promise}
   */ destroy() {
        return new $faa91f5616b3e685$var$npo_src((resolve)=>{
            $faa91f5616b3e685$var$readyMap.delete(this);
            $faa91f5616b3e685$var$playerMap.delete(this.element);
            if (this._originalElement) {
                $faa91f5616b3e685$var$playerMap.delete(this._originalElement);
                this._originalElement.removeAttribute('data-vimeo-initialized');
            }
            if (this.element && this.element.nodeName === 'IFRAME' && this.element.parentNode) {
                // If we've added an additional wrapper div, remove that from the DOM.
                // If not, just remove the iframe element.
                if (this.element.parentNode.parentNode && this._originalElement && this._originalElement !== this.element.parentNode) this.element.parentNode.parentNode.removeChild(this.element.parentNode);
                else this.element.parentNode.removeChild(this.element);
            }
            // If the clip is private there is a case where the element stays the
            // div element. Destroy should reset the div and remove the iframe child.
            if (this.element && this.element.nodeName === 'DIV' && this.element.parentNode) {
                this.element.removeAttribute('data-vimeo-initialized');
                const iframe = this.element.querySelector('iframe');
                if (iframe && iframe.parentNode) {
                    // If we've added an additional wrapper div, remove that from the DOM.
                    // If not, just remove the iframe element.
                    if (iframe.parentNode.parentNode && this._originalElement && this._originalElement !== iframe.parentNode) iframe.parentNode.parentNode.removeChild(iframe.parentNode);
                    else iframe.parentNode.removeChild(iframe);
                }
            }
            this._window.removeEventListener('message', this._onMessage);
            if ($faa91f5616b3e685$var$screenfull.isEnabled) $faa91f5616b3e685$var$screenfull.off('fullscreenchange', this.fullscreenchangeHandler);
            resolve();
        });
    }
    /**
   * A promise to get the autopause behavior of the video.
   *
   * @promise GetAutopausePromise
   * @fulfill {boolean} Whether autopause is turned on or off.
   * @reject {UnsupportedError} Autopause is not supported with the current
   *         player or browser.
   */ /**
   * Get the autopause behavior for this player.
   *
   * @return {GetAutopausePromise}
   */ getAutopause() {
        return this.get('autopause');
    }
    /**
   * A promise to set the autopause behavior of the video.
   *
   * @promise SetAutopausePromise
   * @fulfill {boolean} Whether autopause is turned on or off.
   * @reject {UnsupportedError} Autopause is not supported with the current
   *         player or browser.
   */ /**
   * Enable or disable the autopause behavior of this player.
   *
   * By default, when another video is played in the same browser, this
   * player will automatically pause. Unless you have a specific reason
   * for doing so, we recommend that you leave autopause set to the
   * default (`true`).
   *
   * @param {boolean} autopause
   * @return {SetAutopausePromise}
   */ setAutopause(autopause) {
        return this.set('autopause', autopause);
    }
    /**
   * A promise to get the buffered property of the video.
   *
   * @promise GetBufferedPromise
   * @fulfill {Array} Buffered Timeranges converted to an Array.
   */ /**
   * Get the buffered property of the video.
   *
   * @return {GetBufferedPromise}
   */ getBuffered() {
        return this.get('buffered');
    }
    /**
   * @typedef {Object} CameraProperties
   * @prop {number} props.yaw - Number between 0 and 360.
   * @prop {number} props.pitch - Number between -90 and 90.
   * @prop {number} props.roll - Number between -180 and 180.
   * @prop {number} props.fov - The field of view in degrees.
   */ /**
   * A promise to get the camera properties of the player.
   *
   * @promise GetCameraPromise
   * @fulfill {CameraProperties} The camera properties.
   */ /**
   * For 360° videos get the camera properties for this player.
   *
   * @return {GetCameraPromise}
   */ getCameraProps() {
        return this.get('cameraProps');
    }
    /**
   * A promise to set the camera properties of the player.
   *
   * @promise SetCameraPromise
   * @fulfill {Object} The camera was successfully set.
   * @reject {RangeError} The range was out of bounds.
   */ /**
   * For 360° videos set the camera properties for this player.
   *
   * @param {CameraProperties} camera The camera properties
   * @return {SetCameraPromise}
   */ setCameraProps(camera) {
        return this.set('cameraProps', camera);
    }
    /**
   * A representation of a chapter.
   *
   * @typedef {Object} VimeoChapter
   * @property {number} startTime The start time of the chapter.
   * @property {object} title The title of the chapter.
   * @property {number} index The place in the order of Chapters. Starts at 1.
   */ /**
   * A promise to get chapters for the video.
   *
   * @promise GetChaptersPromise
   * @fulfill {VimeoChapter[]} The chapters for the video.
   */ /**
   * Get an array of all the chapters for the video.
   *
   * @return {GetChaptersPromise}
   */ getChapters() {
        return this.get('chapters');
    }
    /**
   * A promise to get the currently active chapter.
   *
   * @promise GetCurrentChaptersPromise
   * @fulfill {VimeoChapter|undefined} The current chapter for the video.
   */ /**
   * Get the currently active chapter for the video.
   *
   * @return {GetCurrentChaptersPromise}
   */ getCurrentChapter() {
        return this.get('currentChapter');
    }
    /**
   * A promise to get the accent color of the player.
   *
   * @promise GetColorPromise
   * @fulfill {string} The hex color of the player.
   */ /**
   * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
   *
   * @return {GetColorPromise}
   */ getColor() {
        return this.get('color');
    }
    /**
   * A promise to get all colors for the player in an array.
   *
   * @promise GetColorsPromise
   * @fulfill {string[]} The hex colors of the player.
   */ /**
   * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
   *
   * @return {GetColorPromise}
   */ getColors() {
        return $faa91f5616b3e685$var$npo_src.all([
            this.get('colorOne'),
            this.get('colorTwo'),
            this.get('colorThree'),
            this.get('colorFour')
        ]);
    }
    /**
   * A promise to set the accent color of the player.
   *
   * @promise SetColorPromise
   * @fulfill {string} The color was successfully set.
   * @reject {TypeError} The string was not a valid hex or rgb color.
   * @reject {ContrastError} The color was set, but the contrast is
   *         outside of the acceptable range.
   * @reject {EmbedSettingsError} The owner of the player has chosen to
   *         use a specific color.
   */ /**
   * Set the accent color of this player to a hex or rgb string. Setting the
   * color may fail if the owner of the video has set their embed
   * preferences to force a specific color.
   * Note this is deprecated in place of `setColorTwo`.
   *
   * @param {string} color The hex or rgb color string to set.
   * @return {SetColorPromise}
   */ setColor(color) {
        return this.set('color', color);
    }
    /**
   * A promise to set all colors for the player.
   *
   * @promise SetColorsPromise
   * @fulfill {string[]} The colors were successfully set.
   * @reject {TypeError} The string was not a valid hex or rgb color.
   * @reject {ContrastError} The color was set, but the contrast is
   *         outside of the acceptable range.
   * @reject {EmbedSettingsError} The owner of the player has chosen to
   *         use a specific color.
   */ /**
   * Set the colors of this player to a hex or rgb string. Setting the
   * color may fail if the owner of the video has set their embed
   * preferences to force a specific color.
   * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
   * If a color should not be set, the index in the array can be left as null.
   *
   * @param {string[]} colors Array of the hex or rgb color strings to set.
   * @return {SetColorsPromise}
   */ setColors(colors) {
        if (!Array.isArray(colors)) return new $faa91f5616b3e685$var$npo_src((resolve, reject)=>reject(new TypeError('Argument must be an array.')));
        const nullPromise = new $faa91f5616b3e685$var$npo_src((resolve)=>resolve(null));
        const colorPromises = [
            colors[0] ? this.set('colorOne', colors[0]) : nullPromise,
            colors[1] ? this.set('colorTwo', colors[1]) : nullPromise,
            colors[2] ? this.set('colorThree', colors[2]) : nullPromise,
            colors[3] ? this.set('colorFour', colors[3]) : nullPromise
        ];
        return $faa91f5616b3e685$var$npo_src.all(colorPromises);
    }
    /**
   * A representation of a cue point.
   *
   * @typedef {Object} VimeoCuePoint
   * @property {number} time The time of the cue point.
   * @property {object} data The data passed when adding the cue point.
   * @property {string} id The unique id for use with removeCuePoint.
   */ /**
   * A promise to get the cue points of a video.
   *
   * @promise GetCuePointsPromise
   * @fulfill {VimeoCuePoint[]} The cue points added to the video.
   * @reject {UnsupportedError} Cue points are not supported with the current
   *         player or browser.
   */ /**
   * Get an array of the cue points added to the video.
   *
   * @return {GetCuePointsPromise}
   */ getCuePoints() {
        return this.get('cuePoints');
    }
    /**
   * A promise to get the current time of the video.
   *
   * @promise GetCurrentTimePromise
   * @fulfill {number} The current time in seconds.
   */ /**
   * Get the current playback position in seconds.
   *
   * @return {GetCurrentTimePromise}
   */ getCurrentTime() {
        return this.get('currentTime');
    }
    /**
   * A promise to set the current time of the video.
   *
   * @promise SetCurrentTimePromise
   * @fulfill {number} The actual current time that was set.
   * @reject {RangeError} the time was less than 0 or greater than the
   *         video’s duration.
   */ /**
   * Set the current playback position in seconds. If the player was
   * paused, it will remain paused. Likewise, if the player was playing,
   * it will resume playing once the video has buffered.
   *
   * You can provide an accurate time and the player will attempt to seek
   * to as close to that time as possible. The exact time will be the
   * fulfilled value of the promise.
   *
   * @param {number} currentTime
   * @return {SetCurrentTimePromise}
   */ setCurrentTime(currentTime) {
        return this.set('currentTime', currentTime);
    }
    /**
   * A promise to get the duration of the video.
   *
   * @promise GetDurationPromise
   * @fulfill {number} The duration in seconds.
   */ /**
   * Get the duration of the video in seconds. It will be rounded to the
   * nearest second before playback begins, and to the nearest thousandth
   * of a second after playback begins.
   *
   * @return {GetDurationPromise}
   */ getDuration() {
        return this.get('duration');
    }
    /**
   * A promise to get the ended state of the video.
   *
   * @promise GetEndedPromise
   * @fulfill {boolean} Whether or not the video has ended.
   */ /**
   * Get the ended state of the video. The video has ended if
   * `currentTime === duration`.
   *
   * @return {GetEndedPromise}
   */ getEnded() {
        return this.get('ended');
    }
    /**
   * A promise to get the loop state of the player.
   *
   * @promise GetLoopPromise
   * @fulfill {boolean} Whether or not the player is set to loop.
   */ /**
   * Get the loop state of the player.
   *
   * @return {GetLoopPromise}
   */ getLoop() {
        return this.get('loop');
    }
    /**
   * A promise to set the loop state of the player.
   *
   * @promise SetLoopPromise
   * @fulfill {boolean} The loop state that was set.
   */ /**
   * Set the loop state of the player. When set to `true`, the player
   * will start over immediately once playback ends.
   *
   * @param {boolean} loop
   * @return {SetLoopPromise}
   */ setLoop(loop) {
        return this.set('loop', loop);
    }
    /**
   * A promise to set the muted state of the player.
   *
   * @promise SetMutedPromise
   * @fulfill {boolean} The muted state that was set.
   */ /**
   * Set the muted state of the player. When set to `true`, the player
   * volume will be muted.
   *
   * @param {boolean} muted
   * @return {SetMutedPromise}
   */ setMuted(muted) {
        return this.set('muted', muted);
    }
    /**
   * A promise to get the muted state of the player.
   *
   * @promise GetMutedPromise
   * @fulfill {boolean} Whether or not the player is muted.
   */ /**
   * Get the muted state of the player.
   *
   * @return {GetMutedPromise}
   */ getMuted() {
        return this.get('muted');
    }
    /**
   * A promise to get the paused state of the player.
   *
   * @promise GetLoopPromise
   * @fulfill {boolean} Whether or not the video is paused.
   */ /**
   * Get the paused state of the player.
   *
   * @return {GetLoopPromise}
   */ getPaused() {
        return this.get('paused');
    }
    /**
   * A promise to get the playback rate of the player.
   *
   * @promise GetPlaybackRatePromise
   * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
   */ /**
   * Get the playback rate of the player on a scale from `0` to `2`.
   *
   * @return {GetPlaybackRatePromise}
   */ getPlaybackRate() {
        return this.get('playbackRate');
    }
    /**
   * A promise to set the playbackrate of the player.
   *
   * @promise SetPlaybackRatePromise
   * @fulfill {number} The playback rate was set.
   * @reject {RangeError} The playback rate was less than 0 or greater than 2.
   */ /**
   * Set the playback rate of the player on a scale from `0` to `2`. When set
   * via the API, the playback rate will not be synchronized to other
   * players or stored as the viewer's preference.
   *
   * @param {number} playbackRate
   * @return {SetPlaybackRatePromise}
   */ setPlaybackRate(playbackRate) {
        return this.set('playbackRate', playbackRate);
    }
    /**
   * A promise to get the played property of the video.
   *
   * @promise GetPlayedPromise
   * @fulfill {Array} Played Timeranges converted to an Array.
   */ /**
   * Get the played property of the video.
   *
   * @return {GetPlayedPromise}
   */ getPlayed() {
        return this.get('played');
    }
    /**
   * A promise to get the qualities available of the current video.
   *
   * @promise GetQualitiesPromise
   * @fulfill {Array} The qualities of the video.
   */ /**
   * Get the qualities of the current video.
   *
   * @return {GetQualitiesPromise}
   */ getQualities() {
        return this.get('qualities');
    }
    /**
   * A promise to get the current set quality of the video.
   *
   * @promise GetQualityPromise
   * @fulfill {string} The current set quality.
   */ /**
   * Get the current set quality of the video.
   *
   * @return {GetQualityPromise}
   */ getQuality() {
        return this.get('quality');
    }
    /**
   * A promise to set the video quality.
   *
   * @promise SetQualityPromise
   * @fulfill {number} The quality was set.
   * @reject {RangeError} The quality is not available.
   */ /**
   * Set a video quality.
   *
   * @param {string} quality
   * @return {SetQualityPromise}
   */ setQuality(quality) {
        return this.set('quality', quality);
    }
    /**
   * A promise to get the remote playback availability.
   *
   * @promise RemotePlaybackAvailabilityPromise
   * @fulfill {boolean} Whether remote playback is available.
   */ /**
   * Get the availability of remote playback.
   *
   * @return {RemotePlaybackAvailabilityPromise}
   */ getRemotePlaybackAvailability() {
        return this.get('remotePlaybackAvailability');
    }
    /**
   * A promise to get the current remote playback state.
   *
   * @promise RemotePlaybackStatePromise
   * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
   */ /**
   * Get the current remote playback state.
   *
   * @return {RemotePlaybackStatePromise}
   */ getRemotePlaybackState() {
        return this.get('remotePlaybackState');
    }
    /**
   * A promise to get the seekable property of the video.
   *
   * @promise GetSeekablePromise
   * @fulfill {Array} Seekable Timeranges converted to an Array.
   */ /**
   * Get the seekable property of the video.
   *
   * @return {GetSeekablePromise}
   */ getSeekable() {
        return this.get('seekable');
    }
    /**
   * A promise to get the seeking property of the player.
   *
   * @promise GetSeekingPromise
   * @fulfill {boolean} Whether or not the player is currently seeking.
   */ /**
   * Get if the player is currently seeking.
   *
   * @return {GetSeekingPromise}
   */ getSeeking() {
        return this.get('seeking');
    }
    /**
   * A promise to get the text tracks of a video.
   *
   * @promise GetTextTracksPromise
   * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
   */ /**
   * Get an array of the text tracks that exist for the video.
   *
   * @return {GetTextTracksPromise}
   */ getTextTracks() {
        return this.get('textTracks');
    }
    /**
   * A promise to get the audio tracks of a video.
   *
   * @promise GetAudioTracksPromise
   * @fulfill {VimeoAudioTrack[]} The audio tracks associated with the video.
   */ /**
   * Get an array of the audio tracks that exist for the video.
   *
   * @return {GetAudioTracksPromise}
   */ getAudioTracks() {
        return this.get('audioTracks');
    }
    /**
   * A promise to get the enabled audio track of a video.
   *
   * @promise GetAudioTrackPromise
   * @fulfill {VimeoAudioTrack} The enabled audio track.
   */ /**
   * Get the enabled audio track for a video.
   *
   * @return {GetAudioTrackPromise}
   */ getEnabledAudioTrack() {
        return this.get('enabledAudioTrack');
    }
    /**
   * Get the main audio track for a video.
   *
   * @return {GetAudioTrackPromise}
   */ getDefaultAudioTrack() {
        return this.get('defaultAudioTrack');
    }
    /**
   * A promise to get the embed code for the video.
   *
   * @promise GetVideoEmbedCodePromise
   * @fulfill {string} The `<iframe>` embed code for the video.
   */ /**
   * Get the `<iframe>` embed code for the video.
   *
   * @return {GetVideoEmbedCodePromise}
   */ getVideoEmbedCode() {
        return this.get('videoEmbedCode');
    }
    /**
   * A promise to get the id of the video.
   *
   * @promise GetVideoIdPromise
   * @fulfill {number} The id of the video.
   */ /**
   * Get the id of the video.
   *
   * @return {GetVideoIdPromise}
   */ getVideoId() {
        return this.get('videoId');
    }
    /**
   * A promise to get the title of the video.
   *
   * @promise GetVideoTitlePromise
   * @fulfill {number} The title of the video.
   */ /**
   * Get the title of the video.
   *
   * @return {GetVideoTitlePromise}
   */ getVideoTitle() {
        return this.get('videoTitle');
    }
    /**
   * A promise to get the native width of the video.
   *
   * @promise GetVideoWidthPromise
   * @fulfill {number} The native width of the video.
   */ /**
   * Get the native width of the currently‐playing video. The width of
   * the highest‐resolution available will be used before playback begins.
   *
   * @return {GetVideoWidthPromise}
   */ getVideoWidth() {
        return this.get('videoWidth');
    }
    /**
   * A promise to get the native height of the video.
   *
   * @promise GetVideoHeightPromise
   * @fulfill {number} The native height of the video.
   */ /**
   * Get the native height of the currently‐playing video. The height of
   * the highest‐resolution available will be used before playback begins.
   *
   * @return {GetVideoHeightPromise}
   */ getVideoHeight() {
        return this.get('videoHeight');
    }
    /**
   * A promise to get the vimeo.com url for the video.
   *
   * @promise GetVideoUrlPromise
   * @fulfill {number} The vimeo.com url for the video.
   * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
   */ /**
   * Get the vimeo.com url for the video.
   *
   * @return {GetVideoUrlPromise}
   */ getVideoUrl() {
        return this.get('videoUrl');
    }
    /**
   * A promise to get the volume level of the player.
   *
   * @promise GetVolumePromise
   * @fulfill {number} The volume level of the player on a scale from 0 to 1.
   */ /**
   * Get the current volume level of the player on a scale from `0` to `1`.
   *
   * Most mobile devices do not support an independent volume from the
   * system volume. In those cases, this method will always return `1`.
   *
   * @return {GetVolumePromise}
   */ getVolume() {
        return this.get('volume');
    }
    /**
   * A promise to set the volume level of the player.
   *
   * @promise SetVolumePromise
   * @fulfill {number} The volume was set.
   * @reject {RangeError} The volume was less than 0 or greater than 1.
   */ /**
   * Set the volume of the player on a scale from `0` to `1`. When set
   * via the API, the volume level will not be synchronized to other
   * players or stored as the viewer’s preference.
   *
   * Most mobile devices do not support setting the volume. An error will
   * *not* be triggered in that situation.
   *
   * @param {number} volume
   * @return {SetVolumePromise}
   */ setVolume(volume) {
        return this.set('volume', volume);
    }
    /** @typedef {import('timing-object').ITimingObject} TimingObject */ /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */ /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */ /**
   * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
   *
   * @param {TimingObject} timingObject
   * @param {TimingSrcConnectorOptions} options
   *
   * @return {Promise<TimingSrcConnector>}
   */ async setTimingSrc(timingObject, options) {
        if (!timingObject) throw new TypeError('A Timing Object must be provided.');
        await this.ready();
        const connector = new $faa91f5616b3e685$var$TimingSrcConnector(this, timingObject, options);
        $faa91f5616b3e685$var$postMessage(this, 'notifyTimingObjectConnect');
        connector.addEventListener('disconnect', ()=>$faa91f5616b3e685$var$postMessage(this, 'notifyTimingObjectDisconnect'));
        return connector;
    }
}
// Setup embed only if this is not a server runtime
if (!$faa91f5616b3e685$var$isServerRuntime) {
    $faa91f5616b3e685$var$screenfull = $faa91f5616b3e685$var$initializeScreenfull();
    $faa91f5616b3e685$var$initializeEmbeds();
    $faa91f5616b3e685$var$resizeEmbeds();
    $faa91f5616b3e685$var$initAppendVideoMetadata();
    $faa91f5616b3e685$var$checkUrlTimeParam();
    $faa91f5616b3e685$var$updateDRMEmbeds();
}
var $faa91f5616b3e685$export$2e2bcd8739ae039 = $faa91f5616b3e685$var$Player;

});

parcelRegister("f5sus", function(module, exports) {

$parcel$export(module.exports, "toggleAriaExpanded", () => $afbd6c33c795e19c$export$40ba32d7e7abefe9);
$parcel$export(module.exports, "FocusTrap", () => $afbd6c33c795e19c$export$34eba2437817a67b);
// Utility for toggling aria-expanded attribute
function $afbd6c33c795e19c$export$40ba32d7e7abefe9(element, expand) {
    if (expand === undefined) expand = element.getAttribute('aria-expanded') === 'false';
    element.setAttribute('aria-expanded', expand);
}
function $afbd6c33c795e19c$export$d0a8044dce8ff2fc() {
    return window.matchMedia('(max-width: 60em)').matches;
}
class $afbd6c33c795e19c$export$34eba2437817a67b {
    constructor(element, focusableEls){
        this.element = element;
        this.focusableEls = focusableEls ?? this.constructor.getFocusableEls(element);
        this.firstFocusableEl = this.focusableEls[0];
        this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
        this._handler = this._handleKeydown.bind(this);
    }
    static getFocusableEls(element) {
        return element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    }
    enable() {
        document.addEventListener('keydown', this._handler);
    }
    disable() {
        document.removeEventListener('keydown', this._handler);
    }
    _handleKeydown(e) {
        if (!(e.key === 'Tab' || e.keyCode === 9)) return;
        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        } else if (document.activeElement === this.lastFocusableEl) {
            this.firstFocusableEl.focus();
            e.preventDefault();
        }
    }
}

});

parcelRegister("2bvox", function(module, exports) {

$parcel$export(module.exports, "gsap", () => $1974f63041948ee8$export$99ee26438460406a);

var $bvJM2 = parcelRequire("bvJM2");

var $aMBlh = parcelRequire("aMBlh");
var $1974f63041948ee8$export$99ee26438460406a = (0, $bvJM2.gsap).registerPlugin((0, $aMBlh.CSSPlugin)) || (0, $bvJM2.gsap), // to protect from tree shaking
$1974f63041948ee8$export$7b23975ad686bf91 = $1974f63041948ee8$export$99ee26438460406a.core.Tween;

});
parcelRegister("bvJM2", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.15.0
 * https://gsap.com
 *
 * @license Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _randomExp = /random\([^)]+\)/g, _commaDelimExp = /,\s*/g, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, // takes any value and returns an Array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
// for distributing values across an Array. Can accept a number, a function or (most commonly) an object which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array.
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(s) {
    return s.replace(_randomExp, function(match) {
        //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
        var arIndex = match.indexOf("[") + 1, values = match.substring(arIndex || 7, arIndex ? match.indexOf("]") : match.length - 1).split(_commaDelimExp);
        return random(arIndex ? values : +values[0], arIndex ? 0 : +values[1], +values[2] || 1e-5);
    });
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !this._initted && this._dur && _totalTime || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = _roundPrecise(value);
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, this._start - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this, prevProm = self._prom;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                prevProm && prevProm();
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    if (this.vars.repeatRefresh && !isYoyo) {
                        this.invalidate()._lock = 1;
                        prevIteration = iteration; // otherwise, the onStart() may fire on the 2nd iteration.
                    }
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !!timeScale; // as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && dur && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        amount = _roundPrecise(amount);
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += _roundPrecise(start / self._ts);
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, reverseEase = vars.easeReverse || yoyoEase, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._rEase = reverseEase && (_parseEase(reverseEase) || tween._ease);
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (tween._from) tween.ratio = 1;
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) // from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset. Try splitting into individual properties") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,easeReverse,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            var easeReverse = vars.easeReverse || vars.yoyoEase;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    easeReverse && (copy.easeReverse = easeReverse);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) time = dur - time;
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) //repeatRefresh functionality
                {
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            if (this._rEase) {
                var inv = time < prevTime;
                if (inv !== this._inv) {
                    var segDur = inv ? prevTime : dur - prevTime;
                    this._inv = inv;
                    if (this._from) this.ratio = 1 - this.ratio;
                    this._invRatio = this.ratio;
                    this._invTime = prevTime;
                    this._invRecip = segDur ? (inv ? -1 : 1) / segDur : 0;
                    this._invScale = inv ? -this.ratio : 1 - this.ratio;
                    this._invEase = inv ? this._rEase : this._ease;
                }
                this.ratio = ratio = this._invRatio + this._invScale * this._invEase((time - this._invTime) * this._invRecip);
            } else this.ratio = ratio = this._ease(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger,easeReverse", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.15.0";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("aMBlh", function(module, exports) {

$parcel$export(module.exports, "CSSPlugin", () => $7d9b5a7dd4dbaff5$export$855822f522f18eef);
/*!
 * CSSPlugin 3.15.0
 * https://gsap.com
 *
 * Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $bvJM2 = parcelRequire("bvJM2");
var $7d9b5a7dd4dbaff5$var$_win, $7d9b5a7dd4dbaff5$var$_doc, $7d9b5a7dd4dbaff5$var$_docElement, $7d9b5a7dd4dbaff5$var$_pluginInitted, $7d9b5a7dd4dbaff5$var$_tempDiv, $7d9b5a7dd4dbaff5$var$_tempDivStyler, $7d9b5a7dd4dbaff5$var$_recentSetterPlugin, $7d9b5a7dd4dbaff5$var$_reverting, $7d9b5a7dd4dbaff5$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $7d9b5a7dd4dbaff5$var$_transformProps = {}, $7d9b5a7dd4dbaff5$var$_RAD2DEG = 180 / Math.PI, $7d9b5a7dd4dbaff5$var$_DEG2RAD = Math.PI / 180, $7d9b5a7dd4dbaff5$var$_atan2 = Math.atan2, $7d9b5a7dd4dbaff5$var$_bigNum = 1e8, $7d9b5a7dd4dbaff5$var$_capsExp = /([A-Z])/g, $7d9b5a7dd4dbaff5$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $7d9b5a7dd4dbaff5$var$_complexExp = /[\s,\(]\S/, $7d9b5a7dd4dbaff5$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $7d9b5a7dd4dbaff5$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginningAndEnd = function _renderCSSPropWithBeginningAndEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $7d9b5a7dd4dbaff5$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $7d9b5a7dd4dbaff5$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $7d9b5a7dd4dbaff5$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_transformProp = "transform", $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin", $7d9b5a7dd4dbaff5$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $7d9b5a7dd4dbaff5$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $7d9b5a7dd4dbaff5$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $7d9b5a7dd4dbaff5$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $7d9b5a7dd4dbaff5$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $7d9b5a7dd4dbaff5$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($7d9b5a7dd4dbaff5$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, isNotCSS, "");
        }
        property = $7d9b5a7dd4dbaff5$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $7d9b5a7dd4dbaff5$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $7d9b5a7dd4dbaff5$var$_reverting();
        if ((!i || !i.isStart) && !style[$7d9b5a7dd4dbaff5$var$_transformProp]) {
            $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]) {
                style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $7d9b5a7dd4dbaff5$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $7d9b5a7dd4dbaff5$var$_revertStyle,
        save: $7d9b5a7dd4dbaff5$var$_saveStyle
    };
    target._gsap || (0, $bvJM2.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $7d9b5a7dd4dbaff5$var$_supports3D, $7d9b5a7dd4dbaff5$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $7d9b5a7dd4dbaff5$var$_doc.createElementNS ? $7d9b5a7dd4dbaff5$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $7d9b5a7dd4dbaff5$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $7d9b5a7dd4dbaff5$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $7d9b5a7dd4dbaff5$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($7d9b5a7dd4dbaff5$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $7d9b5a7dd4dbaff5$var$_prefixes[i] : "") + property;
}, $7d9b5a7dd4dbaff5$var$_initCore = function _initCore() {
    if ($7d9b5a7dd4dbaff5$var$_windowExists() && window.document) {
        $7d9b5a7dd4dbaff5$var$_win = window;
        $7d9b5a7dd4dbaff5$var$_doc = $7d9b5a7dd4dbaff5$var$_win.document;
        $7d9b5a7dd4dbaff5$var$_docElement = $7d9b5a7dd4dbaff5$var$_doc.documentElement;
        $7d9b5a7dd4dbaff5$var$_tempDiv = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $7d9b5a7dd4dbaff5$var$_tempDivStyler = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div");
        $7d9b5a7dd4dbaff5$var$_transformProp = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b($7d9b5a7dd4dbaff5$var$_transformProp);
        $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin";
        $7d9b5a7dd4dbaff5$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $7d9b5a7dd4dbaff5$var$_supports3D = !!$7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b("perspective");
        $7d9b5a7dd4dbaff5$var$_reverting = (0, $bvJM2.gsap).core.reverting;
        $7d9b5a7dd4dbaff5$var$_pluginInitted = 1;
    }
}, $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $7d9b5a7dd4dbaff5$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $7d9b5a7dd4dbaff5$var$_docElement.removeChild(svg);
    return bbox;
}, $7d9b5a7dd4dbaff5$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $7d9b5a7dd4dbaff5$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$7d9b5a7dd4dbaff5$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp) property = $7d9b5a7dd4dbaff5$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $7d9b5a7dd4dbaff5$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $7d9b5a7dd4dbaff5$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$7d9b5a7dd4dbaff5$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $7d9b5a7dd4dbaff5$var$_tempDiv.style, horizontal = $7d9b5a7dd4dbaff5$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[unit] || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($7d9b5a7dd4dbaff5$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $bvJM2._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $7d9b5a7dd4dbaff5$var$_doc || !parent.appendChild) parent = $7d9b5a7dd4dbaff5$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $bvJM2._ticker).time && !cache.uncache) return (0, $bvJM2._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $7d9b5a7dd4dbaff5$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$7d9b5a7dd4dbaff5$var$_nonStandardLayouts[$7d9b5a7dd4dbaff5$var$_getComputedProperty(parent, "display")] && (style.position = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($7d9b5a7dd4dbaff5$var$_tempDiv);
            px = $7d9b5a7dd4dbaff5$var$_tempDiv[measureProperty];
            parent.removeChild($7d9b5a7dd4dbaff5$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $bvJM2._getCache)(parent);
            cache.time = (0, $bvJM2._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $bvJM2._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $7d9b5a7dd4dbaff5$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore();
    if (property in $7d9b5a7dd4dbaff5$var$_propertyAliases && property !== "transform") {
        property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($7d9b5a7dd4dbaff5$var$_transformProps[property] && property !== "transform") {
        value = $7d9b5a7dd4dbaff5$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $7d9b5a7dd4dbaff5$var$_firstTwoOnly($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $7d9b5a7dd4dbaff5$var$_specialProps[property] && $7d9b5a7dd4dbaff5$var$_specialProps[property](target, property, unit) || $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, property) || (0, $bvJM2._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $bvJM2.PropTween)(this._pt, target.style, prop, 0, 1, (0, $bvJM2._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $bvJM2._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $bvJM2._numWithUnitExp)) || [];
    endValues = end.match((0, $bvJM2._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $bvJM2._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $bvJM2._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $bvJM2._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $bvJM2._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue;
    (0, $bvJM2._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $7d9b5a7dd4dbaff5$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[x] || x;
    split[1] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $7d9b5a7dd4dbaff5$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($7d9b5a7dd4dbaff5$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $7d9b5a7dd4dbaff5$var$_transformOriginProp : $7d9b5a7dd4dbaff5$var$_transformProp;
                }
                $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$7d9b5a7dd4dbaff5$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, 0, 0, $7d9b5a7dd4dbaff5$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $7d9b5a7dd4dbaff5$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $7d9b5a7dd4dbaff5$var$_rotationalProperties = {}, $7d9b5a7dd4dbaff5$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
    return $7d9b5a7dd4dbaff5$var$_isNullTransform(matrixString) ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrixString.substr(7).match((0, $bvJM2._numExp)).map((0, $bvJM2._round));
}, $7d9b5a7dd4dbaff5$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $bvJM2._getCache)(target), style = target.style, matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrix;
    } else if (matrix === $7d9b5a7dd4dbaff5$var$_identity2DMatrix && !target.offsetParent && target !== $7d9b5a7dd4dbaff5$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $7d9b5a7dd4dbaff5$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $7d9b5a7dd4dbaff5$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $7d9b5a7dd4dbaff5$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $7d9b5a7dd4dbaff5$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $7d9b5a7dd4dbaff5$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $7d9b5a7dd4dbaff5$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $bvJM2.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$7d9b5a7dd4dbaff5$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$7d9b5a7dd4dbaff5$var$_transformProp] !== "none" ? cs[$7d9b5a7dd4dbaff5$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $7d9b5a7dd4dbaff5$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $7d9b5a7dd4dbaff5$var$_atan2(b, a) * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $7d9b5a7dd4dbaff5$var$_atan2(c, d) * $7d9b5a7dd4dbaff5$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $7d9b5a7dd4dbaff5$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a32, a33);
            rotationX = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $7d9b5a7dd4dbaff5$var$_atan2(-c, a33);
            rotationY = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $7d9b5a7dd4dbaff5$var$_atan2(b, a);
            rotation = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $bvJM2._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $bvJM2._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$7d9b5a7dd4dbaff5$var$_isNullTransform($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $bvJM2._round)(scaleX);
    cache.scaleY = (0, $bvJM2._round)(scaleY);
    cache.rotation = (0, $bvJM2._round)(rotation) + deg;
    cache.rotationX = (0, $bvJM2._round)(rotationX) + deg;
    cache.rotationY = (0, $bvJM2._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = $7d9b5a7dd4dbaff5$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $bvJM2._config).force3D;
    cache.renderTransform = cache.svg ? $7d9b5a7dd4dbaff5$var$_renderSVGTransforms : $7d9b5a7dd4dbaff5$var$_supports3D ? $7d9b5a7dd4dbaff5$var$_renderCSSTransforms : $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $7d9b5a7dd4dbaff5$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$7d9b5a7dd4dbaff5$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $bvJM2.getUnit)(start);
    return (0, $bvJM2._round)(parseFloat(start) + parseFloat($7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $7d9b5a7dd4dbaff5$var$_renderCSSTransforms(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_zeroDeg = "0deg", $7d9b5a7dd4dbaff5$var$_zeroPx = "0px", $7d9b5a7dd4dbaff5$var$_endParenthesis = ") ", $7d9b5a7dd4dbaff5$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $7d9b5a7dd4dbaff5$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += "perspective(" + transformPerspective + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $7d9b5a7dd4dbaff5$var$_zeroPx || y !== $7d9b5a7dd4dbaff5$var$_zeroPx || z !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += z !== $7d9b5a7dd4dbaff5$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotation !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotate(" + rotation + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateY(" + rotationY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateX(" + rotationX + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (skewX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || skewY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms || "translate(0, 0)";
}, $7d9b5a7dd4dbaff5$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        skewX *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $bvJM2._round)(a11);
        a21 = (0, $bvJM2._round)(a21);
        a12 = (0, $bvJM2._round)(a12);
        a22 = (0, $bvJM2._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", x, "px");
        ty = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $bvJM2._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $bvJM2._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $bvJM2._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $bvJM2._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $7d9b5a7dd4dbaff5$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $bvJM2._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $7d9b5a7dd4dbaff5$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, startNum, change, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $7d9b5a7dd4dbaff5$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $7d9b5a7dd4dbaff5$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$7d9b5a7dd4dbaff5$var$_transformProp];
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = startValue;
    }
    for(p in $7d9b5a7dd4dbaff5$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $bvJM2.getUnit)(startValue);
            endUnit = (0, $bvJM2.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $bvJM2.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $7d9b5a7dd4dbaff5$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $bvJM2._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $7d9b5a7dd4dbaff5$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $7d9b5a7dd4dbaff5$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $7d9b5a7dd4dbaff5$export$855822f522f18eef = {
    name: "css",
    register: $7d9b5a7dd4dbaff5$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps, finalTransformValue;
        $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $7d9b5a7dd4dbaff5$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $bvJM2._plugins)[p] && (0, $bvJM2._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $7d9b5a7dd4dbaff5$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $bvJM2._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $bvJM2._colorExp).lastIndex = 0;
                if (!(0, $bvJM2._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $bvJM2.getUnit)(startValue);
                    endUnit = (0, $bvJM2.getUnit)(endValue);
                    endUnit ? startUnit !== endUnit && (startValue = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                }
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $bvJM2._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $bvJM2._replaceRandom)(startValue));
                    (0, $bvJM2.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $bvJM2._config).units[p] || (0, $bvJM2.getUnit)($7d9b5a7dd4dbaff5$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $7d9b5a7dd4dbaff5$var$_get(target, p)); // can't work with relative values
                } else startValue = $7d9b5a7dd4dbaff5$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $7d9b5a7dd4dbaff5$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $7d9b5a7dd4dbaff5$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $7d9b5a7dd4dbaff5$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $7d9b5a7dd4dbaff5$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    finalTransformValue = endValue; // this is always the same as endValue except when it's a var(--) value, in which case we need to calculate the end value.
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        if (endValue.substring(0, 5) === "calc(") {
                            var origPerspective = target.style.perspective;
                            target.style.perspective = endValue;
                            endValue = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "perspective");
                            origPerspective ? target.style.perspective = origPerspective : $7d9b5a7dd4dbaff5$var$_removeProperty(target, "perspective");
                        }
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $7d9b5a7dd4dbaff5$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $bvJM2.PropTween)(this._pt, style, $7d9b5a7dd4dbaff5$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $bvJM2.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $bvJM2._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, 0, style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]);
                        endValue = $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, p, $7d9b5a7dd4dbaff5$var$_firstTwoOnly(startValue), $7d9b5a7dd4dbaff5$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $7d9b5a7dd4dbaff5$var$_rotationalProperties) {
                        $7d9b5a7dd4dbaff5$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $bvJM2._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $7d9b5a7dd4dbaff5$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$7d9b5a7dd4dbaff5$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $bvJM2.getUnit)(endValue) || (p in (0, $bvJM2._config).units ? (0, $bvJM2._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $bvJM2.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $bvJM2._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp : $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (isTransformRelated && finalTransformValue !== endValue) {
                        this._pt.b = startValue;
                        this._pt.e = finalTransformValue;
                        this._pt.r = $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginningAndEnd;
                    } else if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $bvJM2._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $bvJM2._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$7d9b5a7dd4dbaff5$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $7d9b5a7dd4dbaff5$var$_get,
    aliases: $7d9b5a7dd4dbaff5$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp && (target._gsap.x || $7d9b5a7dd4dbaff5$var$_get(target, "x")) ? plugin && $7d9b5a7dd4dbaff5$var$_recentSetterPlugin === plugin ? property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScale : $7d9b5a7dd4dbaff5$var$_setterTransform : ($7d9b5a7dd4dbaff5$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScaleWithRender : $7d9b5a7dd4dbaff5$var$_setterTransformWithRender) : target.style && !(0, $bvJM2._isUndefined)(target.style[property]) ? $7d9b5a7dd4dbaff5$var$_setterCSSStyle : ~property.indexOf("-") ? $7d9b5a7dd4dbaff5$var$_setterCSSProp : (0, $bvJM2._getSetter)(target, property);
    },
    core: {
        _removeProperty: $7d9b5a7dd4dbaff5$var$_removeProperty,
        _getMatrix: $7d9b5a7dd4dbaff5$var$_getMatrix
    }
};
(0, $bvJM2.gsap).utils.checkPrefix = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b;
(0, $bvJM2.gsap).core.getStyleSaver = $7d9b5a7dd4dbaff5$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $bvJM2._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $7d9b5a7dd4dbaff5$var$_transformProps[name] = 1;
    });
    (0, $bvJM2._forEachName)(rotation, function(name) {
        (0, $bvJM2._config).units[name] = "deg";
        $7d9b5a7dd4dbaff5$var$_rotationalProperties[name] = 1;
    });
    $7d9b5a7dd4dbaff5$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $bvJM2._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $7d9b5a7dd4dbaff5$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $bvJM2._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $bvJM2._config).units[name] = "px";
});
(0, $bvJM2.gsap).registerPlugin($7d9b5a7dd4dbaff5$export$855822f522f18eef);

});


function $3898885b5c8ce990$var$isNumber(subject) {
    return typeof subject === 'number';
}
function $3898885b5c8ce990$var$isString(subject) {
    return typeof subject === 'string';
}
function $3898885b5c8ce990$var$isBoolean(subject) {
    return typeof subject === 'boolean';
}
function $3898885b5c8ce990$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $3898885b5c8ce990$var$mathAbs(n) {
    return Math.abs(n);
}
function $3898885b5c8ce990$var$mathSign(n) {
    return Math.sign(n);
}
function $3898885b5c8ce990$var$deltaAbs(valueB, valueA) {
    return $3898885b5c8ce990$var$mathAbs(valueB - valueA);
}
function $3898885b5c8ce990$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($3898885b5c8ce990$var$mathAbs(valueB) <= $3898885b5c8ce990$var$mathAbs(valueA)) return 0;
    const diff = $3898885b5c8ce990$var$deltaAbs($3898885b5c8ce990$var$mathAbs(valueB), $3898885b5c8ce990$var$mathAbs(valueA));
    return $3898885b5c8ce990$var$mathAbs(diff / valueB);
}
function $3898885b5c8ce990$var$roundToTwoDecimals(num) {
    return Math.round(num * 100) / 100;
}
function $3898885b5c8ce990$var$arrayKeys(array) {
    return $3898885b5c8ce990$var$objectKeys(array).map(Number);
}
function $3898885b5c8ce990$var$arrayLast(array) {
    return array[$3898885b5c8ce990$var$arrayLastIndex(array)];
}
function $3898885b5c8ce990$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $3898885b5c8ce990$var$arrayIsLastIndex(array, index) {
    return index === $3898885b5c8ce990$var$arrayLastIndex(array);
}
function $3898885b5c8ce990$var$arrayFromNumber(n, startAt = 0) {
    return Array.from(Array(n), (_, i)=>startAt + i);
}
function $3898885b5c8ce990$var$objectKeys(object) {
    return Object.keys(object);
}
function $3898885b5c8ce990$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce((mergedObjects, currentObject)=>{
        $3898885b5c8ce990$var$objectKeys(currentObject).forEach((key)=>{
            const valueA = mergedObjects[key];
            const valueB = currentObject[key];
            const areObjects = $3898885b5c8ce990$var$isObject(valueA) && $3898885b5c8ce990$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $3898885b5c8ce990$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $3898885b5c8ce990$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}
function $3898885b5c8ce990$var$Alignment(align, viewSize) {
    const predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function measure(n, index) {
        if ($3898885b5c8ce990$var$isString(align)) return predefined[align](n);
        return align(viewSize, n, index);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $3898885b5c8ce990$var$EventStore() {
    let listeners = [];
    function add(node, type, handler, options = {
        passive: true
    }) {
        let removeListener;
        if ('addEventListener' in node) {
            node.addEventListener(type, handler, options);
            removeListener = ()=>node.removeEventListener(type, handler, options);
        } else {
            const legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = ()=>legacyMediaQueryList.removeListener(handler);
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter((remove)=>remove());
    }
    const self = {
        add: add,
        clear: clear
    };
    return self;
}
function $3898885b5c8ce990$var$Animations(ownerDocument, ownerWindow, update, render) {
    const documentVisibleHandler = $3898885b5c8ce990$var$EventStore();
    const fixedTimeStep = 1000 / 60;
    let lastTimeStamp = null;
    let accumulatedTime = 0;
    let animationId = 0;
    function init() {
        documentVisibleHandler.add(ownerDocument, 'visibilitychange', ()=>{
            if (ownerDocument.hidden) reset();
        });
    }
    function destroy() {
        stop();
        documentVisibleHandler.clear();
    }
    function animate(timeStamp) {
        if (!animationId) return;
        if (!lastTimeStamp) {
            lastTimeStamp = timeStamp;
            update();
            update();
        }
        const timeElapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        accumulatedTime += timeElapsed;
        while(accumulatedTime >= fixedTimeStep){
            update();
            accumulatedTime -= fixedTimeStep;
        }
        const alpha = accumulatedTime / fixedTimeStep;
        render(alpha);
        if (animationId) animationId = ownerWindow.requestAnimationFrame(animate);
    }
    function start() {
        if (animationId) return;
        animationId = ownerWindow.requestAnimationFrame(animate);
    }
    function stop() {
        ownerWindow.cancelAnimationFrame(animationId);
        lastTimeStamp = null;
        accumulatedTime = 0;
        animationId = 0;
    }
    function reset() {
        lastTimeStamp = null;
        accumulatedTime = 0;
    }
    const self = {
        init: init,
        destroy: destroy,
        start: start,
        stop: stop,
        update: update,
        render: render
    };
    return self;
}
function $3898885b5c8ce990$var$Axis(axis, contentDirection) {
    const isRightToLeft = contentDirection === 'rtl';
    const isVertical = axis === 'y';
    const scroll = isVertical ? 'y' : 'x';
    const cross = isVertical ? 'x' : 'y';
    const sign = !isVertical && isRightToLeft ? -1 : 1;
    const startEdge = getStartEdge();
    const endEdge = getEndEdge();
    function measureSize(nodeRect) {
        const { height: height, width: width } = nodeRect;
        return isVertical ? height : width;
    }
    function getStartEdge() {
        if (isVertical) return 'top';
        return isRightToLeft ? 'right' : 'left';
    }
    function getEndEdge() {
        if (isVertical) return 'bottom';
        return isRightToLeft ? 'left' : 'right';
    }
    function direction(n) {
        return n * sign;
    }
    const self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize,
        direction: direction
    };
    return self;
}
function $3898885b5c8ce990$var$Limit(min = 0, max = 0) {
    const length = $3898885b5c8ce990$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    const self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $3898885b5c8ce990$var$Counter(max, start, loop) {
    const { constrain: constrain } = $3898885b5c8ce990$var$Limit(0, max);
    const loopEnd = max + 1;
    let counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $3898885b5c8ce990$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return clone().set(get() + n);
    }
    function clone() {
        return $3898885b5c8ce990$var$Counter(max, get(), loop);
    }
    const self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $3898885b5c8ce990$var$DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
    const { cross: crossAxis, direction: direction } = axis;
    const focusNodes = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ];
    const nonPassiveEvent = {
        passive: false
    };
    const initEvents = $3898885b5c8ce990$var$EventStore();
    const dragEvents = $3898885b5c8ce990$var$EventStore();
    const goToNextThreshold = $3898885b5c8ce990$var$Limit(50, 225).constrain(percentOfView.measure(20));
    const snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    const freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    const baseSpeed = dragFree ? 43 : 25;
    let isMoving = false;
    let startScroll = 0;
    let startCross = 0;
    let pointerIsDown = false;
    let preventScroll = false;
    let preventClick = false;
    let isMouse = false;
    function init(emblaApi) {
        if (!watchDrag) return;
        function downIfAllowed(evt) {
            if ($3898885b5c8ce990$var$isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
        }
        const node = rootNode;
        initEvents.add(node, 'dragstart', (evt)=>evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', ()=>undefined, nonPassiveEvent).add(node, 'touchend', ()=>undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
    }
    function destroy() {
        initEvents.clear();
        dragEvents.clear();
    }
    function addDragEvents() {
        const node = isMouse ? ownerDocument : rootNode;
        dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
    }
    function isFocusNode(node) {
        const nodeName = node.nodeName || '';
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        const boost = dragFree ? freeForceBoost : snapForceBoost;
        const type = isMouse ? 'mouse' : 'touch';
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        const next = index.add($3898885b5c8ce990$var$mathSign(force) * -1);
        const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $3898885b5c8ce990$var$mathAbs(force) < goToNextThreshold) return baseForce;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        const isMouseEvt = $3898885b5c8ce990$var$isMouseEvent(evt, ownerWindow);
        isMouse = isMouseEvt;
        preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $3898885b5c8ce990$var$deltaAbs(target.get(), location.get()) >= 2;
        if (isMouseEvt && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        addDragEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit('pointerDown');
    }
    function move(evt) {
        const isTouchEvt = !$3898885b5c8ce990$var$isMouseEvent(evt, ownerWindow);
        if (isTouchEvt && evt.touches.length >= 2) return up(evt);
        const lastScroll = dragTracker.readPoint(evt);
        const lastCross = dragTracker.readPoint(evt, crossAxis);
        const diffScroll = $3898885b5c8ce990$var$deltaAbs(lastScroll, startScroll);
        const diffCross = $3898885b5c8ce990$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        const diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(0.75);
        animation.start();
        target.add(direction(diff));
        evt.preventDefault();
    }
    function up(evt) {
        const currentLocation = scrollTarget.byDistance(0, false);
        const targetChanged = currentLocation.index !== index.get();
        const rawForce = dragTracker.pointerUp(evt) * forceBoost();
        const force = allowedForce(direction(rawForce), targetChanged);
        const forceFactor = $3898885b5c8ce990$var$factorAbs(rawForce, force);
        const speed = baseSpeed - 10 * forceFactor;
        const friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        dragEvents.clear();
        scrollBody.useDuration(speed).useFriction(friction);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit('pointerUp');
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
            preventClick = false;
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    const self = {
        init: init,
        destroy: destroy,
        pointerDown: pointerDown
    };
    return self;
}
function $3898885b5c8ce990$var$DragTracker(axis, ownerWindow) {
    const logInterval = 170;
    let startEvent;
    let lastEvent;
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        const property = evtAxis || axis.scroll;
        const coord = `client${property === 'x' ? 'X' : 'Y'}`;
        return ($3898885b5c8ce990$var$isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        const diff = readPoint(evt) - readPoint(lastEvent);
        const expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        const diffTime = readTime(evt) - readTime(startEvent);
        const expired = readTime(evt) - readTime(lastEvent) > logInterval;
        const force = diffDrag / diffTime;
        const isFlick = diffTime && !expired && $3898885b5c8ce990$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    const self = {
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $3898885b5c8ce990$var$NodeRects() {
    function measure(node) {
        const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = node;
        const offset = {
            top: offsetTop,
            right: offsetLeft + offsetWidth,
            bottom: offsetTop + offsetHeight,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight
        };
        return offset;
    }
    const self = {
        measure: measure
    };
    return self;
}
function $3898885b5c8ce990$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $3898885b5c8ce990$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
    const observeNodes = [
        container
    ].concat(slides);
    let resizeObserver;
    let containerSize;
    let slideSizes = [];
    let destroyed = false;
    function readSize(node) {
        return axis.measureSize(nodeRects.measure(node));
    }
    function init(emblaApi) {
        if (!watchResize) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        function defaultCallback(entries) {
            for (const entry of entries){
                if (destroyed) return;
                const isContainer = entry.target === container;
                const slideIndex = slides.indexOf(entry.target);
                const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
                const newSize = readSize(isContainer ? container : slides[slideIndex]);
                const diffSize = $3898885b5c8ce990$var$mathAbs(newSize - lastSize);
                if (diffSize >= 0.5) {
                    emblaApi.reInit();
                    eventHandler.emit('resize');
                    break;
                }
            }
        }
        resizeObserver = new ResizeObserver((entries)=>{
            if ($3898885b5c8ce990$var$isBoolean(watchResize) || watchResize(emblaApi, entries)) defaultCallback(entries);
        });
        ownerWindow.requestAnimationFrame(()=>{
            observeNodes.forEach((node)=>resizeObserver.observe(node));
        });
    }
    function destroy() {
        destroyed = true;
        if (resizeObserver) resizeObserver.disconnect();
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
    let scrollVelocity = 0;
    let scrollDirection = 0;
    let scrollDuration = baseDuration;
    let scrollFriction = baseFriction;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    function seek() {
        const displacement = target.get() - location.get();
        const isInstant = !scrollDuration;
        let scrollDistance = 0;
        if (isInstant) {
            scrollVelocity = 0;
            previousLocation.set(target);
            location.set(target);
            scrollDistance = displacement;
        } else {
            previousLocation.set(location);
            scrollVelocity += displacement / scrollDuration;
            scrollVelocity *= scrollFriction;
            rawLocation += scrollVelocity;
            location.add(scrollVelocity);
            scrollDistance = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $3898885b5c8ce990$var$mathSign(scrollDistance);
        rawLocationPrevious = rawLocation;
        return self;
    }
    function settled() {
        const diff = target.get() - offsetLocation.get();
        return $3898885b5c8ce990$var$mathAbs(diff) < 0.001;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return scrollVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(n) {
        scrollDuration = n;
        return self;
    }
    function useFriction(n) {
        scrollFriction = n;
        return self;
    }
    const self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollBounds(limit, location, target, scrollBody, percentOfView) {
    const pullBackThreshold = percentOfView.measure(10);
    const edgeOffsetTolerance = percentOfView.measure(50);
    const frictionLimit = $3898885b5c8ce990$var$Limit(0.1, 0.99);
    let disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(location.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        const edge = limit.reachedMin(location.get()) ? 'min' : 'max';
        const diffToEdge = $3898885b5c8ce990$var$mathAbs(limit[edge] - location.get());
        const diffToTarget = target.get() - location.get();
        const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $3898885b5c8ce990$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    const self = {
        shouldConstrain: shouldConstrain,
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
    const scrollBounds = $3898885b5c8ce990$var$Limit(-contentSize + viewSize, 0);
    const snapsBounded = measureBounded();
    const scrollContainLimit = findScrollContainLimit();
    const snapsContained = measureContained();
    function usePixelTolerance(bound, snap) {
        return $3898885b5c8ce990$var$deltaAbs(bound, snap) <= 1;
    }
    function findScrollContainLimit() {
        const startSnap = snapsBounded[0];
        const endSnap = $3898885b5c8ce990$var$arrayLast(snapsBounded);
        const min = snapsBounded.lastIndexOf(startSnap);
        const max = snapsBounded.indexOf(endSnap) + 1;
        return $3898885b5c8ce990$var$Limit(min, max);
    }
    function measureBounded() {
        return snapsAligned.map((snapAligned, index)=>{
            const { min: min, max: max } = scrollBounds;
            const snap = scrollBounds.constrain(snapAligned);
            const isFirst = !index;
            const isLast = $3898885b5c8ce990$var$arrayIsLastIndex(snapsAligned, index);
            if (isFirst) return max;
            if (isLast) return min;
            if (usePixelTolerance(min, snap)) return min;
            if (usePixelTolerance(max, snap)) return max;
            return snap;
        }).map((scrollBound)=>parseFloat(scrollBound.toFixed(3)));
    }
    function measureContained() {
        if (contentSize <= viewSize + pixelTolerance) return [
            scrollBounds.max
        ];
        if (containScroll === 'keepSnaps') return snapsBounded;
        const { min: min, max: max } = scrollContainLimit;
        return snapsBounded.slice(min, max);
    }
    const self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    const max = scrollSnaps[0];
    const min = loop ? max - contentSize : $3898885b5c8ce990$var$arrayLast(scrollSnaps);
    const limit = $3898885b5c8ce990$var$Limit(min, max);
    const self = {
        limit: limit
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollLooper(contentSize, limit, location, vectors) {
    const jointSafety = 0.1;
    const min = limit.min + jointSafety;
    const max = limit.max + jointSafety;
    const { reachedMin: reachedMin, reachedMax: reachedMax } = $3898885b5c8ce990$var$Limit(min, max);
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(location.get());
        if (direction === -1) return reachedMin(location.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        const loopDistance = contentSize * (direction * -1);
        vectors.forEach((v)=>v.add(loopDistance));
    }
    const self = {
        loop: loop
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollProgress(limit) {
    const { max: max, length: length } = limit;
    function get(n) {
        const currentLocation = n - max;
        return length ? currentLocation / -length : 0;
    }
    const self = {
        get: get
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const { groupSlides: groupSlides } = slidesToScroll;
    const alignments = measureSizes().map(alignment.measure);
    const snaps = measureUnaligned();
    const snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map((rects)=>$3898885b5c8ce990$var$arrayLast(rects)[endEdge] - rects[0][startEdge]).map($3898885b5c8ce990$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map((rect)=>containerRect[startEdge] - rect[startEdge]).map((snap)=>-$3898885b5c8ce990$var$mathAbs(snap));
    }
    function measureAligned() {
        return groupSlides(snaps).map((g)=>g[0]).map((snap, index)=>snap + alignments[index]);
    }
    const self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $3898885b5c8ce990$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
    const { groupSlides: groupSlides } = slidesToScroll;
    const { min: min, max: max } = scrollContainLimit;
    const slideRegistry = createSlideRegistry();
    function createSlideRegistry() {
        const groupedSlideIndexes = groupSlides(slideIndexes);
        const doNotContain = !containSnaps || containScroll === 'keepSnaps';
        if (scrollSnaps.length === 1) return [
            slideIndexes
        ];
        if (doNotContain) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map((group, index, groups)=>{
            const isFirst = !index;
            const isLast = $3898885b5c8ce990$var$arrayIsLastIndex(groups, index);
            if (isFirst) {
                const range = $3898885b5c8ce990$var$arrayLast(groups[0]) + 1;
                return $3898885b5c8ce990$var$arrayFromNumber(range);
            }
            if (isLast) {
                const range = $3898885b5c8ce990$var$arrayLastIndex(slideIndexes) - $3898885b5c8ce990$var$arrayLast(groups)[0] + 1;
                return $3898885b5c8ce990$var$arrayFromNumber(range, $3898885b5c8ce990$var$arrayLast(groups)[0]);
            }
            return group;
        });
    }
    const self = {
        slideRegistry: slideRegistry
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    const { reachedAny: reachedAny, removeOffset: removeOffset, constrain: constrain } = limit;
    function minDistance(distances) {
        return distances.concat().sort((a, b)=>$3898885b5c8ce990$var$mathAbs(a) - $3898885b5c8ce990$var$mathAbs(b))[0];
    }
    function findTargetSnap(target) {
        const distance = loop ? removeOffset(target) : constrain(target);
        const ascDiffsToSnaps = scrollSnaps.map((snap, index)=>({
                diff: shortcut(snap - distance, 0),
                index: index
            })).sort((d1, d2)=>$3898885b5c8ce990$var$mathAbs(d1.diff) - $3898885b5c8ce990$var$mathAbs(d2.diff));
        const { index: index } = ascDiffsToSnaps[0];
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        const targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return target;
        if (!direction) return minDistance(targets);
        const matchingTargets = targets.filter((t)=>$3898885b5c8ce990$var$mathSign(t) === direction);
        if (matchingTargets.length) return minDistance(matchingTargets);
        return $3898885b5c8ce990$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        const diffToSnap = scrollSnaps[index] - targetVector.get();
        const distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        const target = targetVector.get() + distance;
        const { index: index, distance: targetSnapDistance } = findTargetSnap(target);
        const reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        const diffToSnap = scrollSnaps[index] - targetSnapDistance;
        const snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    const self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        const distanceDiff = target.distance;
        const indexDiff = target.index !== indexCurrent.get();
        targetVector.add(distanceDiff);
        if (distanceDiff) {
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit('select');
        }
    }
    function distance(n, snap) {
        const target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        const targetIndex = indexCurrent.clone().set(n);
        const target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    const self = {
        distance: distance,
        index: index
    };
    return self;
}
function $3898885b5c8ce990$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus) {
    const focusListenerOptions = {
        passive: true,
        capture: true
    };
    let lastTabPressTime = 0;
    function init(emblaApi) {
        if (!watchFocus) return;
        function defaultCallback(index) {
            const nowTime = new Date().getTime();
            const diffTime = nowTime - lastTabPressTime;
            if (diffTime > 10) return;
            eventHandler.emit('slideFocusStart');
            root.scrollLeft = 0;
            const group = slideRegistry.findIndex((group)=>group.includes(index));
            if (!$3898885b5c8ce990$var$isNumber(group)) return;
            scrollBody.useDuration(0);
            scrollTo.index(group, 0);
            eventHandler.emit('slideFocus');
        }
        eventStore.add(document, 'keydown', registerTabPress, false);
        slides.forEach((slide, slideIndex)=>{
            eventStore.add(slide, 'focus', (evt)=>{
                if ($3898885b5c8ce990$var$isBoolean(watchFocus) || watchFocus(emblaApi, evt)) defaultCallback(slideIndex);
            }, focusListenerOptions);
        });
    }
    function registerTabPress(event) {
        if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
    }
    const self = {
        init: init
    };
    return self;
}
function $3898885b5c8ce990$var$Vector1D(initialValue) {
    let value = initialValue;
    function get() {
        return value;
    }
    function set(n) {
        value = normalizeInput(n);
    }
    function add(n) {
        value += normalizeInput(n);
    }
    function subtract(n) {
        value -= normalizeInput(n);
    }
    function normalizeInput(n) {
        return $3898885b5c8ce990$var$isNumber(n) ? n : n.get();
    }
    const self = {
        get: get,
        set: set,
        add: add,
        subtract: subtract
    };
    return self;
}
function $3898885b5c8ce990$var$Translate(axis, container) {
    const translate = axis.scroll === 'x' ? x : y;
    const containerStyle = container.style;
    let previousTarget = null;
    let disabled = false;
    function x(n) {
        return `translate3d(${n}px,0px,0px)`;
    }
    function y(n) {
        return `translate3d(0px,${n}px,0px)`;
    }
    function to(target) {
        if (disabled) return;
        const newTarget = $3898885b5c8ce990$var$roundToTwoDecimals(axis.direction(target));
        if (newTarget === previousTarget) return;
        containerStyle.transform = translate(newTarget);
        previousTarget = newTarget;
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = '';
        if (!container.getAttribute('style')) container.removeAttribute('style');
    }
    const self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $3898885b5c8ce990$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
    const roundingSafety = 0.5;
    const ascItems = $3898885b5c8ce990$var$arrayKeys(slideSizesWithGaps);
    const descItems = $3898885b5c8ce990$var$arrayKeys(slideSizesWithGaps).reverse();
    const loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce((a, i)=>{
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce((a, i)=>{
            const remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findSlideBounds(offset) {
        return snaps.map((snap, index)=>({
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            }));
    }
    function findLoopPoints(indexes, offset, isEndEdge) {
        const slideBounds = findSlideBounds(offset);
        return indexes.map((index)=>{
            const initial = isEndEdge ? 0 : -contentSize;
            const altered = isEndEdge ? contentSize : 0;
            const boundEdge = isEndEdge ? 'end' : 'start';
            const loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                loopPoint: loopPoint,
                slideLocation: $3898885b5c8ce990$var$Vector1D(-1),
                translate: $3898885b5c8ce990$var$Translate(axis, slides[index]),
                target: ()=>location.get() > loopPoint ? initial : altered
            };
        });
    }
    function startPoints() {
        const gap = scrollSnaps[0];
        const indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        const gap = viewSize - scrollSnaps[0] - 1;
        const indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(({ index: index })=>{
            const otherIndexes = ascItems.filter((i)=>i !== index);
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach((loopPoint)=>{
            const { target: target, translate: translate, slideLocation: slideLocation } = loopPoint;
            const shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    function clear() {
        loopPoints.forEach((loopPoint)=>loopPoint.translate.clear());
    }
    const self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $3898885b5c8ce990$var$SlidesHandler(container, eventHandler, watchSlides) {
    let mutationObserver;
    let destroyed = false;
    function init(emblaApi) {
        if (!watchSlides) return;
        function defaultCallback(mutations) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                emblaApi.reInit();
                eventHandler.emit('slidesChanged');
                break;
            }
        }
        mutationObserver = new MutationObserver((mutations)=>{
            if (destroyed) return;
            if ($3898885b5c8ce990$var$isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) defaultCallback(mutations);
        });
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $3898885b5c8ce990$var$SlidesInView(container, slides, eventHandler, threshold) {
    const intersectionEntryMap = {};
    let inViewCache = null;
    let notInViewCache = null;
    let intersectionObserver;
    let destroyed = false;
    function init() {
        intersectionObserver = new IntersectionObserver((entries)=>{
            if (destroyed) return;
            entries.forEach((entry)=>{
                const index = slides.indexOf(entry.target);
                intersectionEntryMap[index] = entry;
            });
            inViewCache = null;
            notInViewCache = null;
            eventHandler.emit('slidesInView');
        }, {
            root: container.parentElement,
            threshold: threshold
        });
        slides.forEach((slide)=>intersectionObserver.observe(slide));
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function createInViewList(inView) {
        return $3898885b5c8ce990$var$objectKeys(intersectionEntryMap).reduce((list, slideIndex)=>{
            const index = parseInt(slideIndex);
            const { isIntersecting: isIntersecting } = intersectionEntryMap[index];
            const inViewMatch = inView && isIntersecting;
            const notInViewMatch = !inView && !isIntersecting;
            if (inViewMatch || notInViewMatch) list.push(index);
            return list;
        }, []);
    }
    function get(inView = true) {
        if (inView && inViewCache) return inViewCache;
        if (!inView && notInViewCache) return notInViewCache;
        const slideIndexes = createInViewList(inView);
        if (inView) inViewCache = slideIndexes;
        if (!inView) notInViewCache = slideIndexes;
        return slideIndexes;
    }
    const self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $3898885b5c8ce990$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
    const { measureSize: measureSize, startEdge: startEdge, endEdge: endEdge } = axis;
    const withEdgeGap = slideRects[0] && readEdgeGap;
    const startGap = measureStartGap();
    const endGap = measureEndGap();
    const slideSizes = slideRects.map(measureSize);
    const slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        const slideRect = slideRects[0];
        return $3898885b5c8ce990$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        const style = ownerWindow.getComputedStyle($3898885b5c8ce990$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
    }
    function measureWithGaps() {
        return slideRects.map((rect, index, rects)=>{
            const isFirst = !index;
            const isLast = $3898885b5c8ce990$var$arrayIsLastIndex(rects, index);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($3898885b5c8ce990$var$mathAbs);
    }
    const self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $3898885b5c8ce990$var$SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
    const { startEdge: startEdge, endEdge: endEdge, direction: direction } = axis;
    const groupByNumber = $3898885b5c8ce990$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $3898885b5c8ce990$var$arrayKeys(array).filter((i)=>i % groupSize === 0).map((i)=>array.slice(i, i + groupSize));
    }
    function bySize(array) {
        if (!array.length) return [];
        return $3898885b5c8ce990$var$arrayKeys(array).reduce((groups, rectB, index)=>{
            const rectA = $3898885b5c8ce990$var$arrayLast(groups) || 0;
            const isFirst = rectA === 0;
            const isLast = rectB === $3898885b5c8ce990$var$arrayLastIndex(array);
            const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            const gapA = !loop && isFirst ? direction(startGap) : 0;
            const gapB = !loop && isLast ? direction(endGap) : 0;
            const chunkSize = $3898885b5c8ce990$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map((currentSize, index, groups)=>{
            const previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    const self = {
        groupSlides: groupSlides
    };
    return self;
}
function $3898885b5c8ce990$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
    // Options
    const { align: align, axis: scrollAxis, direction: direction, startIndex: startIndex, loop: loop, duration: duration, dragFree: dragFree, dragThreshold: dragThreshold, inViewThreshold: inViewThreshold, slidesToScroll: groupSlides, skipSnaps: skipSnaps, containScroll: containScroll, watchResize: watchResize, watchSlides: watchSlides, watchDrag: watchDrag, watchFocus: watchFocus } = options;
    // Measurements
    const pixelTolerance = 2;
    const nodeRects = $3898885b5c8ce990$var$NodeRects();
    const containerRect = nodeRects.measure(container);
    const slideRects = slides.map(nodeRects.measure);
    const axis = $3898885b5c8ce990$var$Axis(scrollAxis, direction);
    const viewSize = axis.measureSize(containerRect);
    const percentOfView = $3898885b5c8ce990$var$PercentOfView(viewSize);
    const alignment = $3898885b5c8ce990$var$Alignment(align, viewSize);
    const containSnaps = !loop && !!containScroll;
    const readEdgeGap = loop || !!containScroll;
    const { slideSizes: slideSizes, slideSizesWithGaps: slideSizesWithGaps, startGap: startGap, endGap: endGap } = $3898885b5c8ce990$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
    const slidesToScroll = $3898885b5c8ce990$var$SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
    const { snaps: snaps, snapsAligned: snapsAligned } = $3898885b5c8ce990$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
    const contentSize = -$3898885b5c8ce990$var$arrayLast(snaps) + $3898885b5c8ce990$var$arrayLast(slideSizesWithGaps);
    const { snapsContained: snapsContained, scrollContainLimit: scrollContainLimit } = $3898885b5c8ce990$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
    const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    const { limit: limit } = $3898885b5c8ce990$var$ScrollLimit(contentSize, scrollSnaps, loop);
    // Indexes
    const index = $3898885b5c8ce990$var$Counter($3898885b5c8ce990$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    const indexPrevious = index.clone();
    const slideIndexes = $3898885b5c8ce990$var$arrayKeys(slides);
    // Animation
    const update = ({ dragHandler: dragHandler, scrollBody: scrollBody, scrollBounds: scrollBounds, options: { loop: loop } })=>{
        if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
        scrollBody.seek();
    };
    const render = ({ scrollBody: scrollBody, translate: translate, location: location, offsetLocation: offsetLocation, previousLocation: previousLocation, scrollLooper: scrollLooper, slideLooper: slideLooper, dragHandler: dragHandler, animation: animation, eventHandler: eventHandler, scrollBounds: scrollBounds, options: { loop: loop } }, alpha)=>{
        const shouldSettle = scrollBody.settled();
        const withinBounds = !scrollBounds.shouldConstrain();
        const hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
        const hasSettledAndIdle = hasSettled && !dragHandler.pointerDown();
        if (hasSettledAndIdle) animation.stop();
        const interpolatedLocation = location.get() * alpha + previousLocation.get() * (1 - alpha);
        offsetLocation.set(interpolatedLocation);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation.get());
        if (hasSettledAndIdle) eventHandler.emit('settle');
        if (!hasSettled) eventHandler.emit('scroll');
    };
    const animation = $3898885b5c8ce990$var$Animations(ownerDocument, ownerWindow, ()=>update(engine), (alpha)=>render(engine, alpha));
    // Shared
    const friction = 0.68;
    const startLocation = scrollSnaps[index.get()];
    const location = $3898885b5c8ce990$var$Vector1D(startLocation);
    const previousLocation = $3898885b5c8ce990$var$Vector1D(startLocation);
    const offsetLocation = $3898885b5c8ce990$var$Vector1D(startLocation);
    const target = $3898885b5c8ce990$var$Vector1D(startLocation);
    const scrollBody = $3898885b5c8ce990$var$ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
    const scrollTarget = $3898885b5c8ce990$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    const scrollTo = $3898885b5c8ce990$var$ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
    const scrollProgress = $3898885b5c8ce990$var$ScrollProgress(limit);
    const eventStore = $3898885b5c8ce990$var$EventStore();
    const slidesInView = $3898885b5c8ce990$var$SlidesInView(container, slides, eventHandler, inViewThreshold);
    const { slideRegistry: slideRegistry } = $3898885b5c8ce990$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
    const slideFocus = $3898885b5c8ce990$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus);
    // Engine
    const engine = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        eventHandler: eventHandler,
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        dragHandler: $3898885b5c8ce990$var$DragHandler(axis, root, ownerDocument, ownerWindow, target, $3898885b5c8ce990$var$DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
        eventStore: eventStore,
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        previousLocation: previousLocation,
        options: options,
        resizeHandler: $3898885b5c8ce990$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
        scrollBody: scrollBody,
        scrollBounds: $3898885b5c8ce990$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
        scrollLooper: $3898885b5c8ce990$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            previousLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnaps.map(scrollProgress.get),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $3898885b5c8ce990$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
        slideFocus: slideFocus,
        slidesHandler: $3898885b5c8ce990$var$SlidesHandler(container, eventHandler, watchSlides),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slideRegistry: slideRegistry,
        slidesToScroll: slidesToScroll,
        target: target,
        translate: $3898885b5c8ce990$var$Translate(axis, container)
    };
    return engine;
}
function $3898885b5c8ce990$var$EventHandler() {
    let listeners = {};
    let api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach((e)=>e(api, evt));
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter((e)=>e !== cb);
        return self;
    }
    function clear() {
        listeners = {};
    }
    const self = {
        init: init,
        emit: emit,
        off: off,
        on: on,
        clear: clear
    };
    return self;
}
const $3898885b5c8ce990$var$defaultOptions = {
    align: 'center',
    axis: 'x',
    container: null,
    slides: null,
    containScroll: 'trimSnaps',
    direction: 'ltr',
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startIndex: 0,
    active: true,
    watchDrag: true,
    watchResize: true,
    watchSlides: true,
    watchFocus: true
};
function $3898885b5c8ce990$var$OptionsHandler(ownerWindow) {
    function mergeOptions(optionsA, optionsB) {
        return $3898885b5c8ce990$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        const optionsAtMedia = options.breakpoints || {};
        const matchedMediaOptions = $3898885b5c8ce990$var$objectKeys(optionsAtMedia).filter((media)=>ownerWindow.matchMedia(media).matches).map((media)=>optionsAtMedia[media]).reduce((a, mediaOption)=>mergeOptions(a, mediaOption), {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        return optionsList.map((options)=>$3898885b5c8ce990$var$objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries)=>acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
    }
    const self = {
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $3898885b5c8ce990$var$PluginsHandler(optionsHandler) {
    let activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins.filter(({ options: options })=>optionsHandler.optionsAtMedia(options).active !== false);
        activePlugins.forEach((plugin)=>plugin.init(emblaApi, optionsHandler));
        return plugins.reduce((map, plugin)=>Object.assign(map, {
                [plugin.name]: plugin
            }), {});
    }
    function destroy() {
        activePlugins = activePlugins.filter((plugin)=>plugin.destroy());
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $3898885b5c8ce990$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    const ownerDocument = root.ownerDocument;
    const ownerWindow = ownerDocument.defaultView;
    const optionsHandler = $3898885b5c8ce990$var$OptionsHandler(ownerWindow);
    const pluginsHandler = $3898885b5c8ce990$var$PluginsHandler(optionsHandler);
    const mediaHandlers = $3898885b5c8ce990$var$EventStore();
    const eventHandler = $3898885b5c8ce990$var$EventHandler();
    const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia, optionsMediaQueries: optionsMediaQueries } = optionsHandler;
    const { on: on, off: off, emit: emit } = eventHandler;
    const reInit = reActivate;
    let destroyed = false;
    let engine;
    let optionsBase = mergeOptions($3898885b5c8ce990$var$defaultOptions, $3898885b5c8ce990$export$2e2bcd8739ae039.globalOptions);
    let options = mergeOptions(optionsBase);
    let pluginList = [];
    let pluginApis;
    let container;
    let slides;
    function storeElements() {
        const { container: userContainer, slides: userSlides } = options;
        const customContainer = $3898885b5c8ce990$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        const customSlides = $3898885b5c8ce990$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function createEngine(options) {
        const engine = $3898885b5c8ce990$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
        if (options.loop && !engine.slideLooper.canLoop()) {
            const optionsWithoutLoop = Object.assign({}, options, {
                loop: false
            });
            return createEngine(optionsWithoutLoop);
        }
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        storeElements();
        engine = createEngine(options);
        optionsMediaQueries([
            optionsBase,
            ...pluginList.map(({ options: options })=>options)
        ]).forEach((query)=>mediaHandlers.add(query, 'change', reActivate));
        if (!options.active) return;
        engine.translate.to(engine.location.get());
        engine.animation.init();
        engine.slidesInView.init();
        engine.slideFocus.init(self);
        engine.eventHandler.init(self);
        engine.resizeHandler.init(self);
        engine.slidesHandler.init(self);
        if (engine.options.loop) engine.slideLooper.loop();
        if (container.offsetParent && slides.length) engine.dragHandler.init(self);
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        const startIndex = selectedScrollSnap();
        deActivate();
        activate(mergeOptions({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit('reInit');
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.eventStore.clear();
        engine.translate.clear();
        engine.slideLooper.clear();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        engine.slidesInView.destroy();
        engine.animation.destroy();
        pluginsHandler.destroy();
        mediaHandlers.clear();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        eventHandler.emit('destroy');
        eventHandler.clear();
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        const next = engine.index.add(1).get();
        scrollTo(next, jump, -1);
    }
    function scrollPrev(jump) {
        const prev = engine.index.add(-1).get();
        scrollTo(prev, jump, 1);
    }
    function canScrollNext() {
        const next = engine.index.add(1).get();
        return next !== selectedScrollSnap();
    }
    function canScrollPrev() {
        const prev = engine.index.add(-1).get();
        return prev !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnapList;
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.offsetLocation.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function slidesNotInView() {
        return engine.slidesInView.get(false);
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    const self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        emit: emit,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    setTimeout(()=>eventHandler.emit('init'), 0);
    return self;
}
$3898885b5c8ce990$export$2e2bcd8739ae039.globalOptions = undefined;


const $1694decf3def04ec$var$defaultOptions = {
    direction: 'forward',
    speed: 2,
    startDelay: 1000,
    active: true,
    breakpoints: {},
    playOnInit: true,
    stopOnFocusIn: true,
    stopOnInteraction: true,
    stopOnMouseEnter: false,
    rootNode: null
};
function $1694decf3def04ec$var$getAutoScrollRootNode(emblaApi, rootNode) {
    const emblaRootNode = emblaApi.rootNode();
    return rootNode && rootNode(emblaRootNode) || emblaRootNode;
}
function $1694decf3def04ec$export$2e2bcd8739ae039(userOptions = {}) {
    let options;
    let emblaApi;
    let destroyed;
    let startDelay;
    let timerId = 0;
    let autoScrollActive = false;
    let mouseIsOver = false;
    let defaultScrollBehaviour;
    function init(emblaApiInstance, optionsHandler) {
        emblaApi = emblaApiInstance;
        const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia } = optionsHandler;
        const optionsBase = mergeOptions($1694decf3def04ec$var$defaultOptions, $1694decf3def04ec$export$2e2bcd8739ae039.globalOptions);
        const allOptions = mergeOptions(optionsBase, userOptions);
        options = optionsAtMedia(allOptions);
        if (emblaApi.scrollSnapList().length <= 1) return;
        startDelay = options.startDelay;
        destroyed = false;
        defaultScrollBehaviour = emblaApi.internalEngine().scrollBody;
        const { eventStore: eventStore } = emblaApi.internalEngine();
        const isDraggable = !!emblaApi.internalEngine().options.watchDrag;
        const root = $1694decf3def04ec$var$getAutoScrollRootNode(emblaApi, options.rootNode);
        if (isDraggable) emblaApi.on('pointerDown', pointerDown);
        if (isDraggable && !options.stopOnInteraction) emblaApi.on('pointerUp', pointerUp);
        if (options.stopOnMouseEnter) eventStore.add(root, 'mouseenter', mouseEnter);
        if (options.stopOnMouseEnter && !options.stopOnInteraction) eventStore.add(root, 'mouseleave', mouseLeave);
        if (options.stopOnFocusIn) emblaApi.on('slideFocusStart', stopAutoScroll);
        if (options.stopOnFocusIn && !options.stopOnInteraction) eventStore.add(emblaApi.containerNode(), 'focusout', startAutoScroll);
        if (options.playOnInit) startAutoScroll();
    }
    function destroy() {
        emblaApi.off('pointerDown', pointerDown).off('pointerUp', pointerUp).off('slideFocusStart', stopAutoScroll).off('settle', settle);
        stopAutoScroll();
        destroyed = true;
        autoScrollActive = false;
    }
    function startAutoScroll() {
        if (destroyed) return;
        if (autoScrollActive) return;
        emblaApi.emit('autoScroll:play');
        const engine = emblaApi.internalEngine();
        const { ownerWindow: ownerWindow } = engine;
        timerId = ownerWindow.setTimeout(()=>{
            engine.scrollBody = createAutoScrollBehaviour(engine);
            engine.animation.start();
        }, startDelay);
        autoScrollActive = true;
    }
    function stopAutoScroll() {
        if (destroyed) return;
        if (!autoScrollActive) return;
        emblaApi.emit('autoScroll:stop');
        const engine = emblaApi.internalEngine();
        const { ownerWindow: ownerWindow } = engine;
        engine.scrollBody = defaultScrollBehaviour;
        ownerWindow.clearTimeout(timerId);
        timerId = 0;
        autoScrollActive = false;
    }
    function createAutoScrollBehaviour(engine) {
        const { location: location, previousLocation: previousLocation, offsetLocation: offsetLocation, target: target, scrollTarget: scrollTarget, index: index, indexPrevious: indexPrevious, limit: { reachedMin: reachedMin, reachedMax: reachedMax, constrain: constrain }, options: { loop: loop } } = engine;
        const directionSign = options.direction === 'forward' ? -1 : 1;
        const noop = ()=>self;
        let bodyVelocity = 0;
        let scrollDirection = 0;
        let rawLocation = location.get();
        let rawLocationPrevious = 0;
        let hasSettled = false;
        function seek() {
            let directionDiff = 0;
            previousLocation.set(location);
            bodyVelocity = directionSign * options.speed;
            rawLocation += bodyVelocity;
            location.add(bodyVelocity);
            target.set(location);
            directionDiff = rawLocation - rawLocationPrevious;
            scrollDirection = Math.sign(directionDiff);
            rawLocationPrevious = rawLocation;
            const currentIndex = scrollTarget.byDistance(0, false).index;
            if (index.get() !== currentIndex) {
                indexPrevious.set(index.get());
                index.set(currentIndex);
                emblaApi.emit('select');
            }
            const reachedEnd = options.direction === 'forward' ? reachedMin(offsetLocation.get()) : reachedMax(offsetLocation.get());
            if (!loop && reachedEnd) {
                hasSettled = true;
                const constrainedLocation = constrain(location.get());
                location.set(constrainedLocation);
                target.set(location);
                stopAutoScroll();
            }
            return self;
        }
        const self = {
            direction: ()=>scrollDirection,
            duration: ()=>-1,
            velocity: ()=>bodyVelocity,
            settled: ()=>hasSettled,
            seek: seek,
            useBaseFriction: noop,
            useBaseDuration: noop,
            useFriction: noop,
            useDuration: noop
        };
        return self;
    }
    function pointerDown() {
        if (!mouseIsOver) stopAutoScroll();
    }
    function pointerUp() {
        if (!mouseIsOver) startAutoScrollOnSettle();
    }
    function mouseEnter() {
        mouseIsOver = true;
        stopAutoScroll();
    }
    function mouseLeave() {
        mouseIsOver = false;
        startAutoScroll();
    }
    function settle() {
        emblaApi.off('settle', settle);
        startAutoScroll();
    }
    function startAutoScrollOnSettle() {
        emblaApi.on('settle', settle);
    }
    function play(startDelayOverride) {
        if (typeof startDelayOverride !== 'undefined') startDelay = startDelayOverride;
        startAutoScroll();
    }
    function stop() {
        if (autoScrollActive) stopAutoScroll();
    }
    function reset() {
        if (autoScrollActive) {
            stopAutoScroll();
            startAutoScrollOnSettle();
        }
    }
    function isPlaying() {
        return autoScrollActive;
    }
    const self = {
        name: 'autoScroll',
        options: userOptions,
        init: init,
        destroy: destroy,
        play: play,
        stop: stop,
        reset: reset,
        isPlaying: isPlaying
    };
    return self;
}
$1694decf3def04ec$export$2e2bcd8739ae039.globalOptions = undefined;



var $lwga2 = parcelRequire("lwga2");

var $f5sus = parcelRequire("f5sus");

var $2bvox = parcelRequire("2bvox");
// Header mobile flyout
const $ddfc5978d59f4a1b$var$headerMobileToggle = document.querySelector('.header-mobile-toggle');
const $ddfc5978d59f4a1b$var$headerMobileFlyout = document.querySelector('.header-mobile-flyout');
const $ddfc5978d59f4a1b$var$headerMobileMenu = $ddfc5978d59f4a1b$var$headerMobileFlyout.querySelector('.header-menu');
const $ddfc5978d59f4a1b$var$headerMobileMegamenuToggles = $ddfc5978d59f4a1b$var$headerMobileMenu.querySelectorAll('.header-megamenu-toggle');
const $ddfc5978d59f4a1b$var$headerMobileMegamenuBackButtons = $ddfc5978d59f4a1b$var$headerMobileMenu.querySelectorAll('.header-megamenu-back');
const $ddfc5978d59f4a1b$var$headerFlyoutAnimation = (0, $2bvox.gsap).timeline({
    paused: true,
    defaults: {
        duration: 0.3,
        ease: 'power3.inOut'
    }
}).set($ddfc5978d59f4a1b$var$headerMobileFlyout, {
    yPercent: 10
}).to($ddfc5978d59f4a1b$var$headerMobileFlyout, {
    yPercent: 0,
    autoAlpha: 1
});
function $ddfc5978d59f4a1b$var$toggleFlyout(expand) {
    document.body.classList.toggle('flyout-is-open', expand);
    (0, $f5sus.toggleAriaExpanded)($ddfc5978d59f4a1b$var$headerMobileToggle, expand);
    if (expand) $ddfc5978d59f4a1b$var$headerFlyoutAnimation.play();
    else $ddfc5978d59f4a1b$var$headerFlyoutAnimation.reverse();
}
$ddfc5978d59f4a1b$var$headerMobileToggle.addEventListener('click', ()=>{
    $ddfc5978d59f4a1b$var$toggleFlyout(!document.body.classList.contains('flyout-is-open'));
});
function $ddfc5978d59f4a1b$var$toggleMobileMegamenu(toggle, expand) {
    const megamenu = toggle.nextElementSibling;
    if (expand) {
        (0, $2bvox.gsap).to($ddfc5978d59f4a1b$var$headerMobileMenu, {
            xPercent: -100,
            duration: 0.3,
            height: megamenu.clientHeight,
            ease: 'power3.inOut'
        });
        (0, $2bvox.gsap).to(megamenu, {
            autoAlpha: 1
        });
    } else {
        (0, $2bvox.gsap).to($ddfc5978d59f4a1b$var$headerMobileMenu, {
            xPercent: 0,
            duration: 0.3,
            height: 'auto',
            ease: 'power3.inOut'
        });
        (0, $2bvox.gsap).to(megamenu, {
            autoAlpha: 0
        });
    }
    (0, $f5sus.toggleAriaExpanded)(toggle, expand);
}
$ddfc5978d59f4a1b$var$headerMobileMegamenuToggles.forEach((toggle)=>{
    toggle.addEventListener('click', (e)=>{
        e.preventDefault();
        $ddfc5978d59f4a1b$var$toggleMobileMegamenu(toggle, true);
    });
});
$ddfc5978d59f4a1b$var$headerMobileMegamenuBackButtons.forEach((button)=>{
    button.addEventListener('click', ()=>{
        const megamenu = button.closest('.header-megamenu-flyout');
        const toggle = megamenu.previousElementSibling;
        $ddfc5978d59f4a1b$var$toggleMobileMegamenu(toggle, false);
        toggle.focus();
    });
});
// Header desktop megamenus
// On touch devices, we want to prevent the default link behavior allowing users to open the megamenu without navigating away.
const $ddfc5978d59f4a1b$var$headerMegamenuToggles = document.querySelectorAll('.header-desktop-menu .header-megamenu-toggle');
let $ddfc5978d59f4a1b$var$lastInputType = null;
$ddfc5978d59f4a1b$var$headerMegamenuToggles.forEach((toggle)=>{
    toggle.addEventListener('pointerdown', (e)=>{
        $ddfc5978d59f4a1b$var$lastInputType = e.pointerType;
    });
    toggle.addEventListener('click', (e)=>{
        if ($ddfc5978d59f4a1b$var$lastInputType === 'touch') e.preventDefault();
    });
});
// Header search
const $ddfc5978d59f4a1b$var$headerSearchToggles = document.querySelectorAll('.header-search-toggle');
const $ddfc5978d59f4a1b$var$headerSearchFlyout = document.querySelector('.header-search-flyout');
const $ddfc5978d59f4a1b$var$headerSearchInput = $ddfc5978d59f4a1b$var$headerSearchFlyout.querySelector('.header-search-input');
const $ddfc5978d59f4a1b$var$headerSearchFocusTrap = new (0, $f5sus.FocusTrap)($ddfc5978d59f4a1b$var$headerSearchFlyout);
const $ddfc5978d59f4a1b$var$headerSearchAnimation = (0, $2bvox.gsap).timeline({
    paused: true,
    defaults: {
        duration: 0.3,
        ease: 'power3.inOut'
    }
}).set($ddfc5978d59f4a1b$var$headerSearchFlyout, {
    yPercent: -10
}).to($ddfc5978d59f4a1b$var$headerSearchFlyout, {
    yPercent: 0,
    autoAlpha: 1
});
let $ddfc5978d59f4a1b$var$lastUsedSearchToggle;
function $ddfc5978d59f4a1b$var$toggleSearch(expand) {
    document.body.classList.toggle('search-is-open', expand);
    $ddfc5978d59f4a1b$var$headerSearchToggles.forEach((toggle)=>{
        (0, $f5sus.toggleAriaExpanded)(toggle, expand);
    });
    if (expand) $ddfc5978d59f4a1b$var$headerSearchAnimation.play().then(()=>{
        $ddfc5978d59f4a1b$var$headerSearchFocusTrap.enable();
        $ddfc5978d59f4a1b$var$headerSearchInput.focus();
    });
    else $ddfc5978d59f4a1b$var$headerSearchAnimation.reverse().then(()=>{
        $ddfc5978d59f4a1b$var$headerSearchFocusTrap.disable();
        $ddfc5978d59f4a1b$var$lastUsedSearchToggle?.focus();
    });
}
$ddfc5978d59f4a1b$var$headerSearchToggles.forEach((toggle)=>{
    toggle.addEventListener('click', ()=>{
        const expand = !document.body.classList.contains('search-is-open');
        $ddfc5978d59f4a1b$var$toggleSearch(expand);
        if (expand) $ddfc5978d59f4a1b$var$lastUsedSearchToggle = toggle;
    });
});
// Scroll detection class
function $ddfc5978d59f4a1b$var$handleScroll() {
    document.body.classList.toggle('user-has-scrolled', window.scrollY > 0);
}
window.addEventListener('scroll', $ddfc5978d59f4a1b$var$handleScroll);
$ddfc5978d59f4a1b$var$handleScroll();
// Sliders
const $ddfc5978d59f4a1b$var$sliderBlocks = document.querySelectorAll('[data-slider]');
$ddfc5978d59f4a1b$var$sliderBlocks.forEach((block)=>{
    const container = block.querySelector('[data-slider-container]');
    const autoscroll = container?.dataset.autoscroll === 'true';
    const prevButton = block.querySelector('[data-slider-prev]');
    const nextButton = block.querySelector('[data-slider-next]');
    const plugins = [];
    const options = {
        align: 'start'
    };
    if (autoscroll) {
        plugins.push((0, $1694decf3def04ec$export$2e2bcd8739ae039)({
            stopOnInteraction: false,
            stopOnMouseEnter: true,
            speed: 1
        }));
        options.loop = true;
    }
    const embla = (0, $3898885b5c8ce990$export$2e2bcd8739ae039)(container, options, plugins);
    if (prevButton && nextButton) {
        function updateSlider() {
            prevButton.disabled = !embla.canScrollPrev();
            nextButton.disabled = !embla.canScrollNext();
        }
        window.addEventListener('resize', ()=>updateSlider());
        embla.on('select', updateSlider);
        updateSlider();
        prevButton.addEventListener('click', ()=>embla.scrollPrev());
        nextButton.addEventListener('click', ()=>embla.scrollNext());
    }
});
// Accordion blocks
const $ddfc5978d59f4a1b$var$accordionBlocks = document.querySelectorAll('.accordion');
$ddfc5978d59f4a1b$var$accordionBlocks.forEach((block)=>{
    const items = block.querySelectorAll('.accordion-item');
    items.forEach((item)=>{
        const toggle = item.querySelector('.accordion-item-toggle');
        const collapse = item.querySelector('.accordion-item-collapse');
        item.animation = (0, $2bvox.gsap).timeline({
            paused: true,
            defaults: {
                duration: 0.3,
                ease: 'power3.inOut'
            }
        }).set(collapse, {
            display: 'block',
            height: 'auto'
        }).from(collapse, {
            height: 0
        });
        toggle.addEventListener('click', ()=>{
            const isExpanded = item.classList.contains('open');
            // Close all items
            items.forEach((otherItem)=>{
                const otherToggle = otherItem.querySelector('.accordion-item-toggle');
                (0, $f5sus.toggleAriaExpanded)(otherToggle, false);
                otherItem.classList.remove('open');
                otherItem.animation.reverse();
            });
            // Open clicked item if it was closed
            if (!isExpanded) {
                (0, $f5sus.toggleAriaExpanded)(toggle, true);
                item.classList.add('open');
                item.animation.play();
            }
        });
    });
});
// Vimeo background videos
const $ddfc5978d59f4a1b$var$videoElements = document.querySelectorAll('[data-video-url]');
$ddfc5978d59f4a1b$var$videoElements.forEach((videoElement)=>{
    const toggleButton = videoElement.querySelector('[data-video-toggle]');
    const player = new (0, $lwga2.default)(videoElement, {
        url: videoElement.dataset.videoUrl,
        background: true
    });
    videoElement.classList.add('playing');
    toggleButton?.addEventListener('click', ()=>{
        player.getPaused().then((paused)=>{
            videoElement.classList.toggle('playing', paused);
            paused ? player.play() : player.pause();
        });
    });
});
// Tips visibility
const $ddfc5978d59f4a1b$var$tipsContainer = document.querySelector('.tips');
if ($ddfc5978d59f4a1b$var$tipsContainer) {
    const tipItems = $ddfc5978d59f4a1b$var$tipsContainer.querySelectorAll('.tip');
    if (tipItems.length) {
        const STORAGE_KEY = 'closedTips';
        function getClosedTips() {
            try {
                return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
            } catch  {
                return [];
            }
        }
        function markTipClosed(tipId) {
            const closed = getClosedTips();
            if (!closed.includes(tipId)) {
                closed.push(tipId);
                localStorage.setItem(STORAGE_KEY, JSON.stringify(closed));
            }
        }
        function showTip(tip) {
            tip.classList.add('visible');
            $ddfc5978d59f4a1b$var$tipsContainer.classList.add('visible');
        }
        function closeTip(tip) {
            markTipClosed(tip.dataset.tipId);
            tip.classList.remove('visible');
            if (!$ddfc5978d59f4a1b$var$tipsContainer.querySelector('.tip.visible')) $ddfc5978d59f4a1b$var$tipsContainer.classList.remove('visible');
        }
        const closedTips = getClosedTips();
        tipItems.forEach((tip)=>{
            const tipId = tip.dataset.tipId;
            if (closedTips.includes(tipId)) return;
            const triggerType = tip.dataset.triggerType;
            const delay = parseFloat(tip.dataset.delay) || 0;
            const scrollPosition = parseInt(tip.dataset.scrollPosition) || 0;
            if (triggerType === 'direct') showTip(tip);
            else if (triggerType === 'time') setTimeout(()=>showTip(tip), delay * 1000);
            else if (triggerType === 'scroll') {
                const onScroll = ()=>{
                    if (window.scrollY >= scrollPosition) {
                        showTip(tip);
                        window.removeEventListener('scroll', onScroll);
                    }
                };
                window.addEventListener('scroll', onScroll, {
                    passive: true
                });
                onScroll();
            }
            tip.querySelector('.tip-close')?.addEventListener('click', ()=>closeTip(tip));
        });
    }
}

})();
//# sourceMappingURL=index.js.map
